if(navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
	document.write('<link type="text/css" media="screen" rel="stylesheet" href="css/safari.css" />');
	document.write('<link type="text/css" rel="stylesheet" media="only screen and (max-device-width: 480px)" href="css/iphone.css" />');
	document.write('<link type="text/css" rel="stylesheet" media="only screen and (min-device-width: 768px) and (max-device-width: 1024px)" href="css/iphone.css" />');
}

function isBlank(str) {
    return !str || /^\s*$/.test(str);
}

// Copied from underscore.js
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function throttleByPromise(handler) {
    var isInProgress = false;
    return function() {
        if (isInProgress) {
            return;
        }
        isInProgress = true;
        var result = handler();
        if (result) {
            if (typeof result.always === 'function') {
                result.always(function() {
                    isInProgress = false;
                });
            } else if (typeof result.finally === 'function') {
                result.finally(function() {
                    isInProgress = false;
                });
            } else {
                isInProgress = false;
            }
        } else {
            isInProgress = false;
        }
    };
}

function getParameterByName(name, url) {
	url = url || window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function appendJS(file,callback){
    var head=document.getElementsByTagName("head")[0];
    var script=document.createElement('script');
    script.src=file;
    script.type='text/javascript';
	if (callback != undefined) {
		//real browsers
		script.onload=callback;
		//Internet explorer
		script.onreadystatechange = function() {
			if (script.readyState == 'loaded') {
				callback();
			}
		}
	}
    head.appendChild(script);
}

function fixMultiple() {
	var selectVal;
	$("select[multiple]").each(function(){
		selectVal = $(this).val();
		if (selectVal == null) {
			$(this).val('');
		}
	});
}

var popupStatus = 0;
var videoStatus = 0;

function loadPopup(onComplete){
//loads popup only if it is disabled
if(popupStatus==0){
	$("#backgroundPopup").fadeIn("slow", onComplete);
	$("#popupContact").fadeIn("slow",function(){
		//weird chrome lightbox hack
		if (window.chrome) {
			if ($('#popupContact #agentproposal').get(0)) {
				$("#customPopupDiv").height($("#agentproposal").height()+40); //big enough to get rid of scrollbars
				$("#customPopupDiv").height($("#customPopupDiv").height()-20); //bring it back
				$("#popupContact").height($("#agentproposal").height()+40);
			}
		}
	});
	popupStatus = 1;

	initPlaceholders();
}
}

function initPlaceholders() {
	if (!$.support.placeholder) {
		var active = document.activeElement;
		$(':text, textarea').focus(function() {
			if ($(this).attr('placeholder') != '' && $(this).val() == $(this).attr('placeholder')) {
				$(this).val('').removeClass('hasPlaceholder');
			}
		}).blur(function() {
			if ($(this).attr('placeholder') != '' && $(this).attr('placeholder') != undefined && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder'))) {
				$(this).val($(this).attr('placeholder'));
				$(this).addClass('hasPlaceholder');
			}
		});
		$(':text, textarea').blur();
		$(active).focus();
		$('form').submit(function() {
			$(this).find('.hasPlaceholder').each(function() {
				$(this).val('');
			});
		});
	}
}

function initBubbletips() {
	$.fn.tooltip && $('.bubbletip').tooltip({
		position: {
			my: 'center top+25',
			at: 'center bottom',
			using: function(position, feedback) {
				$(this).css(position);
				$('<div>')
					.addClass('arrow')
					.addClass(feedback.vertical)
					.addClass(feedback.horizontal)
					.appendTo(this);
			}
		},
		container: 'body'
	});
}

function disablePopup() {
	//disables popup only if it is enabled
	if(popupStatus==1){
		//hack for one-all on agentdetails
		if ($('#customPopupDiv #socialContainer #socialInputs').get(0)) {
			//var should already be set from agentdetails
			socialContainer = $('#socialContainer').detach();
		}
		//ie hack for submitproposal preview
		if ($('#recorded').css('display') == "block" && (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0 || (Object.hasOwnProperty.call(window, "ActiveXObject") && !window.ActiveXObject))) {
			$('#audioContainer').show();
		}
		//hack top stop video for agentproposal
		if (document.getElementById('ytPlayer') != null) {
			if (typeof stopVideo == 'function' || (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0 || (Object.hasOwnProperty.call(window, "ActiveXObject") && !window.ActiveXObject))) {
				document.getElementById('ytPlayer').stopVideo();
			}
		}
		//hack top stop video for sample proposal
		if ($('#customPopupDiv .apBook').get(0)) {
			videoStatus = 1;
		}

    //hack top stop video for how to record pitch
		if ($('#customPopupDiv #videoPropTut').get(0)) {
			videoStatus = 1;
		}

		$("#backgroundPopup").fadeOut("slow");
		$("#popupContact").fadeOut("slow", function() {
            destroyPopup();
            var closeHandler = $(this).data('onCloseHandler');
            closeHandler && closeHandler();
		});
		popupStatus = 0;
		$("#customPopupDiv").trigger('destroyPopup');
		$('.pushcrew-side-button-mobile').show();
	}
}

function destroyPopup() {
	$("#customPopupDiv").html('');
}

function centerPopup(removepadding, noAutoHeight) {
	var popupHeight;
	var popupWidth;

	//request data for centering
	var windowWidth = document.documentElement.clientWidth;
	var windowHeight = document.documentElement.clientHeight;
	var scrollHeight = $(window).scrollTop();
	var topHeight = 0;
	var leftPos = 0;

	//if (document.documentElement.clientWidth < 768 && ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))  || (navigator.userAgent.match(/android/i)))) {
	if (document.documentElement.clientWidth < 768) {
		$('.pushcrew-side-button-mobile').hide();
		$("#popupContact").css('width','100%');
		$("#popupContact").css('left','.2%');
		if (!noAutoHeight) {
		    $("#popupContact").height('auto');
		}
		$("#popupContact").css('padding','0');
		$("#popupContact").css('border-radius','3px');

		$("#customPopupDiv").css('width','100%');
		if (!noAutoHeight) {
		    $("#customPopupDiv").height('auto');
		}

		$("#customPopupDiv .mediumredbutton").attr('class','btn btn-lg btn-default');

		if (removepadding == true) {
			$("#customPopupDiv").css("padding","20px 0");
		} else {
			$("#customPopupDiv").css("padding","20px");
		}

		$('#popupForm .forminput, #popupForm input[type=text], #popupForm select, #popupForm textarea').css('width', '97%');

		topHeight = scrollHeight+5;
		popupHeight = "auto";
	} else {
		popupHeight = $("#popupContact").height() - 20;
		popupWidth = $("#popupContact").width();

		if (removepadding) {
			$("#customPopupDiv").css("padding",0);
		} else {
			//make it bigger for the border
			$("#customPopupDiv").height(popupHeight+10);
			$("#customPopupDiv").width(popupWidth);
			popupHeight += 20;
			popupWidth += 20;
			$("#popupContact").height(popupHeight+10);
			$("#popupContact").width(popupWidth);
		}
		topHeight = (windowHeight/2-$("#popupContact").outerHeight()/2)+scrollHeight-10;
		topHeight = topHeight < 0 ? 0 : topHeight;
        leftPos = windowWidth/2-$("#popupContact").outerWidth()/2;
	}

	$("#popupContact").css({
		"position": "absolute",
		"top": topHeight,
		"left": leftPos
	});
}

var defaultPopupForm = '<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div>'+
'<div id="customPopupDiv">'+
	'<h1></h1>'+
	'<form action="" id="popupForm" method="POST">'+
		'<div class="formContent"></div>'+
		'<div class="buttons">'+
			'<input id="popupSubmit" type="submit" value="" class="mediumredbutton" />'+
		'</div>'+
	'</form>'+
'</div>';

var forgotPasswordPopupForm =
'<div id="customPopupDiv">'+
	'<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div>'+
	// '<h1></h1>'+
		'<form action="" id="popupForm" method="POST">'+
			'<div class="formContent"></div>'+
			'<div class="buttons">'+
		'<input id="popupSubmit" type="submit" value="" class="mediumredbutton" />'+
		'</div>'+
	'</form>'+
'</div>';

function initYT(url, width, height) {
	var ziggeoRegex = new RegExp('(?:videos/)(.*)(?:/video.mp4)');
	if (url.indexOf('youtube') != -1 || url.indexOf('youtu.be') != -1) {
		showYouTubeVideoPopup(url, false, width, height);
	} else if (ziggeoRegex.test(url)) {
		showYouTubeVideoPopup('https://ziggeo.io/p/' + url.match(ziggeoRegex)[1] + '?height=100%&width=100%', true, width, height);
	} else {
		oldInitYT(url);
	}
}

function showYouTubeVideoPopup(videoUrl, skipvalidation, width, height) {
	if (!skipvalidation && (!videoUrl || !getYouTubeVideoId(videoUrl))) {
		return;
	}

	var $popup = customPopupContent(hb.templates.youTubeVideoPlayer({
		url: videoUrl,
		width: '100%',
		height: '100%',
		isYoutubeVideo: !skipvalidation,
	}), width||900, height || 510);
	var padding = 10, topPadding = 30;
	$popup.css('padding', topPadding + 'px ' + padding + 'px ' + padding + 'px');
	$popup.find('#customPopupDiv').css({
		'width': '100%',
		'height': '100%',
		'padding': 0,
		'margin': 0,
		'overflow': 'hidden',
		'background-color': 'black'
	});

	updatePopupDimensions();
	$(window).resize(updatePopupDimensions);

	function updatePopupDimensions() {
		var videoWidth = $popup.outerWidth() - padding * 2;
		var videoHeight = $popup.outerHeight() - topPadding * 2;
		var isWideScreen = videoWidth/videoHeight > 1.65;
		videoHeight = isWideScreen? (videoWidth  / 16 * 9) : (videoWidth  / 4 * 3);
		$popup.css('height', videoHeight + topPadding + padding);
	}
}

function showAppVideoPromoPopup(mobileType) {
	var $popup = customPopupContent(hb.templates.youTubeVideoPlayer({
		url: 'https://www.youtube.com/embed/QG_t_4ktmdE',
		width: '100%',
		height: '100%',
		mobileAppPromo:true,
		mobileType: mobileType || 'DESKTOP'
	}), 900, 510);
	var padding = 8, topPadding = 8;
	$popup.css('padding', topPadding + 'px ' + padding + 'px ' + padding + 'px');
	$popup.find('#customPopupDiv').css({
		'width': '100%',
		'height': '100%',
		'margin': 0,
		'overflow': 'hidden',
		'padding': '8px',
		'max-width': '998px'
	});

	setTimeout(function(){
		if (!mobileType || mobileType == 'DESKTOP') {
			$popup.find('#customPopupDiv').css('padding', '8px 8px 46px');
		} else {
			$popup.find('#customPopupDiv').css('padding', '8px');
		}
	}, 500)
	
	
	$popup.find('#popupCloseButton').hide();

	updatePopupDimensions();
	$(window).resize(updatePopupDimensions);

	function updatePopupDimensions() {
		var videoWidth = $popup.outerWidth() - padding * 2;
		var videoHeight = videoWidth / 16 * 9;
		$popup.css('height', videoHeight + topPadding + padding);
	}
}

function oldInitYT(url, newWidth, newHeight) {
	newWidth = newWidth ? newWidth : 320;
	newHeight = newHeight ? newHeight : 240;
	$("#popupContact").html('<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div><div id="customPopupDiv"></div>');
	if (url.search('vimeo') != -1) {
		var myNav = navigator.userAgent.toLowerCase();
		var isIE = (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
		if (isIE == 8) {
			var videoId = url.substr(33,9) /*https://player.vimeo.com/external/videoId.sd.mp4*/
			$("#customPopupDiv").html('<iframe src="//player.vimeo.com/video/'+videoId+'" width="'+newWidth+'" height="'+newHeight+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
		} else {
			if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))  || (navigator.userAgent.match(/android/i))) {
				$("#customPopupDiv").html('<video autoplay style="width:100%"><source type="video/mp4" src="'+url+'"></video>');
			} else {
				if (newHeight == 500 && newWidth == 900) {newHeight=507}
				$("#customPopupDiv").html('<div class="flowplayer" data-key="$309113810226719" style="width:'+newWidth+'px;height:'+newHeight+'px"><video autoplay><source type="video/mp4" src="'+url+'"></video></div>');
				$("#customPopupDiv .flowplayer").flowplayer();
			}
		}
	} else if (url.search('youtube') != -1) {
		if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))  || (navigator.userAgent.match(/android/i))) {
			var windowWidth = $(window).width();
			newWidth = windowWidth;
			newHeight = windowWidth * 0.75;
		}
		$("#customPopupDiv").html('<iframe class="youtube-player" enablejsapi="1" type="text/html" width="'+newWidth+'" height="'+newHeight+'" src="'+url+'" frameborder="0"></iframe>');
	}
	if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))  || (navigator.userAgent.match(/android/i))) {
		$("#popupContact").css({
			padding: "0px",
			background: "transparent"
		});
		$('#customPopupDiv').css('box-shadow','none');
	}
	$("#popupContact").width(newWidth);
	$("#popupContact").height(newHeight);
	$("#customPopupDiv").css("height", (newHeight -10) + "px");
	centerPopup(true);
	loadPopup();
	videoStatus = 1;
}

function popupText(text, newWidth, newHeight) {
	newWidth = newWidth ? newWidth : 320;
	newHeight = newHeight ? newHeight : 240;
	$("#popupContact").html('<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div>' +
		'<div id="customPopupDiv" style="text-align:center">'+text +
		'<div style="text-align:center;padding:30px 0 0">' +
		'<a class="mediumredbutton" onclick="disablePopup()" href="javascript:void(0)">OK</a>' +
		'</div>' +
		'</div>');
	$("#popupContact").height(newHeight);
	$("#popupContact").width(newWidth);
	centerPopup();
	loadPopup();
}

function popupSubmitFromCloseButton(str) {
	$("#backgroundPopup").unbind("click");
	$('#popupCloseButton').attr('onclick', '').bind('click', function () {
		$(str).submit();
	});
}

function popupRedirectHome() {
	$("#backgroundPopup").unbind("click");
	$('#popupCloseButton').hide();
}

function initPopup(intent, url, popupTextName) {
	$("#popupContact").width(320);
	$("#popupContact").height(240);
	$("#popupContact").html(defaultPopupForm);
	$("#popupContact h1").html('Comments');
	$("#popupForm .formContent").html('<textarea id="popupText" name="'+popupTextName+'"></textarea>');
	$("#popupForm").attr("action", url);
	$("#popupForm #popupSubmit").attr("value", intent);
	centerPopup();
	loadPopup();
}

var titlesToFixHeightAfterValidation = ['Update Accounting','Mark as Listed','Update Expected Date','In Contract','Mark as Fake', 'Reject'];


function customPopupForm(intent, url, title, newWidth, newHeight, formContent, options, preventDoubleSubmission) {

	var options = options || {};
	var validationOptions = options.validationOptions;
	var popup = $("#popupContact");
	popup.html(defaultPopupForm);
	popup.find('form').validate(validationOptions);
    newWidth = newWidth ? newWidth : 320;
	newHeight = newHeight ? newHeight : 240;
	$("#popupForm").attr("action", url);
	if (preventDoubleSubmission) {
		$('#popupForm').preventDoubleSubmission();
	}
	$("#popupForm #popupSubmit")
		.attr("value", intent)
		.click(function(e) {
            if ($("#popupForm").attr('action').indexOf('addReminderNote')==0) {
                var rnote = $("#popupForm input[name='reminderNote']").val();
                $('span.reminder span').text(rnote);
			}
			e.preventDefault();
			var submitButton = $(this);
			submitButton.closest('form').submit();
			submitButton.prop('disabled', true).addClass('disabled');
            if (titlesToFixHeightAfterValidation.indexOf(title) != -1) {
                var inputErrorsCount = popup.find("label.error:visible").size();
                $("#popupContact").height(newHeight);
                $("#popupContact").height($("#popupContact").height() + inputErrorsCount * 20);
            }
			setTimeout(function() {
				submitButton.prop('disabled', false).removeClass('disabled');
				submitButton.css('background', '#ff9948');
                $('#popupForm .spinner').remove();
			}, 5000);
		});
	$("#popupContact h1").html(title);
	$("#popupForm .formContent").html(formContent);
	$("#popupContact").width(newWidth);
	$("#popupContact").height(newHeight);
	if(options.cssClass){
		popup.addClass(options.cssClass);
	}
	centerPopup();
	loadPopup();
	if (newHeight === 'auto') {
        $("#popupContact, #customPopupDiv").height('auto');
    }
}

function getUrlParameter(name) {
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null
}


// GLOBAL VARIABLES AND REQUEST TO GET CLOSED RESEARCH MEMBERS
var crtUserId; //User selected for an specific request
var crtUsers; // List of Closed research team members

function getClosedResearchTeamMembers(callback) {
	if (crtUsers) {
		if (callback){			
			callback();
		}
	} else {
		$.get("getClosedResearchMembers-json").then(function (data) {
			if(data){
				crtUsers = data;
			}
			if (callback){
				callback();
			}
		}, function (e) {
			if (callback){
				callback();
			}
		});
	}
}

function markAsSoldPopupForm(intent, requestId, buyer, paginationtype, url, title, newWidth, newHeight, formContent, options) {
	var options = options || {};
		var validationOptions = options.validationOptions;
		var popup = $("#popupContact");

		popup.html(defaultPopupForm);
		popup.find('form').validate(validationOptions);

		newWidth = newWidth ? newWidth : 320;
		newHeight = newHeight ? newHeight : 240;

		$("#popupForm").attr("action", url);
		$("#popupForm #popupSubmit")
			.attr("value", intent)
			.click(function(e) {
				e.preventDefault();
				var submitButton = $(this);
				var $submitForm = submitButton.closest('form');
				if (!$submitForm.valid()) {
					return;
				}
				submitButton.prop('disabled', true).addClass('disabled');
				submitButton.attr("value","Submitting...");
				$.post($submitForm.attr('action'), $submitForm.serialize())
					.then(function(data) {
						if (!checkAjax(data)) {
							return;
						}
						var redirectionPath = window.location.pathname + "?requestId=" + requestId + "&buyer=" + buyer
						openLinkInCurrentTab(redirectionPath);
					}).fail(function() {
						defaultAjaxError();
					}).always(function() {
						submitButton.prop('disabled', false).removeClass('disabled');
						disablePopup();
					});
				if (titlesToFixHeightAfterValidation.indexOf(title) != -1 || (title.lastIndexOf('Mark as Sold (', 0) === 0)) {
					var inputErrorsCount = popup.find("label.error:visible").size();
					$("#popupContact").height(newHeight);
					$("#popupContact").height($("#popupContact").height() + inputErrorsCount * 20);
				}
				pagination.type = paginationtype;
			});
		$("#popupContact h1").html(title);
		$("#popupForm .formContent").html(formContent);
		$("#popupContact").width(newWidth);
		$("#popupContact").height(newHeight);
		centerPopup();
		loadPopup();
		getClosedResearchTeamMembers(function () {
			if ($("#crtUserId").length > 0){
				initializeCrtUserDropdown($("#crtUserId"));
				initializeCloseSourceDropdown($("#closeSource"));
			}
		});
}

function initializeCrtUserDropdown(element) {
	if (element){
		var selectedId = $(element).data("selected-user-id");

		$(element).html("");
		$(element).append("<option value=''>Select a CRT user</option>");

		if (crtUsers) {
			crtUsers.forEach(function (user) {
				$(element).append("<option value='" + user.userId + "' " + (selectedId == user.userId ? 'selected' : '') + ">" + user.name + "</option>");
			});
		}
	}
}

function initializeCloseSourceDropdown(element) {
	var closeSources = ['Agent/Broker Audit',
		'UA Request', 'Reports', 'Found and Dug',
		'Corelogic #1 Buyer', 'Corelogic #1 Seller', 'Corelogic #2 Buyer', 'Corelogic #2 Seller', 'Corelogic #3 Buyer', 'Corelogic #3 Seller', 'Corelogic #4 Buyer', 'Corelogic #4 Seller', 'Corelogic #5 Buyer', 'Corelogic #5 Seller', 'Corelogic #6 Buyer', 'Corelogic #6 Seller','MLS Listings Report',
	];
	if (element){
		var selectedCloseSource = $(element).data("selected-close-source");
		$(element).html("");
		$(element).append('<option selected="selected"  value=""> Select a Close Source </option>');
		closeSources.forEach(function (closeSource) {
			console.log(closeSource);
			$(element).append("<option value='" + closeSource + "' " + (selectedCloseSource == closeSource ? 'selected' : '') + ">" + closeSource + "</option>");
		});
	}
}

function customPopupDiv(url, newWidth, newHeight) {
	newWidth = newWidth ? newWidth : 700;
	newHeight = newHeight ? newHeight : 240;
	$("#popupContact").html('<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div><div id="customPopupDiv" style="overflow: auto; height: '+newHeight+'px"></div>');
	$("#customPopupDiv").load(url, function(){initPlaceholders();});
	$("#popupContact").height(newHeight);
	$("#popupContact").width(newWidth);
	centerPopup();
	loadPopup();
}

function customPopupContent(content, newWidth, newHeight, onClose) {
    var $popupContact = $("#popupContact");
    $popupContact.html('<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div><div id="customPopupDiv" style="overflow: auto;"></div>');
	newWidth = newWidth ? newWidth : 320;
	newHeight = newHeight ? newHeight : 240;

    var $customPopupDiv = $("#customPopupDiv");
    $customPopupDiv.html(content);
	$popupContact.width(newWidth).height(newHeight).css('border-radius', '');
	$customPopupDiv.height('');

	var imgAmt = $customPopupDiv.find('img').length;
	if (imgAmt < 1) {
		centerPopup();
		loadPopup();
		newHeight === 'auto' && $('#popupContact, #customPopupDiv').height('auto');
	} else {
		$customPopupDiv.waitForImages(function() {
			centerPopup();
			loadPopup();
            newHeight === 'auto' && $('#popupContact, #customPopupDiv').height('auto');
		});
	}
    typeof onClose === 'function' && $popupContact.data('onCloseHandler', onClose);
	return $popupContact;
}

function openLinkInCurrentTab(url) {
	window.open(url, "_self");
}

function customPopupContentRoundedOpenRef(content, newWidth, newHeight, url) {
	var $popupContact = $("#popupContact");

	$popupContact.addClass("password-changed-popup");
	$popupContact.html('<div id="customPopupDiv" style="overflow: auto;"></div>');
	newWidth = newWidth ? newWidth : 320;
	newHeight = newHeight ? newHeight : 'auto';

	var $customPopupDiv = $("#customPopupDiv");
	$customPopupDiv.html(
	'<div class="content-div-open-ref">' + content + '</div>' +
		'<div class="btn-div btn-div-open-ref">' +
		'    <input type="button" value="OK" class="btn btn-round btn-default" onclick="disablePopup(); openLinkInCurrentTab(\'' + url + '\'); window.location.reload()">' +
		'</div>'
	);

	var $window = $(window);

	if(parseInt(newWidth) >= parseInt($window.width()) - 30) {
		newWidth = parseInt($window.width()) - 60 + "px";
		console.warn(parseInt(newWidth), $window.width(), parseInt($window.width()) - 30 + "px");
		$popupContact.css('width', newWidth + " !important");
		$('#popupContact.password-changed-popup').attr('style', 'width: '+ newWidth +' !important');
	}

	$popupContact
		.height(newHeight)
		.css('border-radius', '9px');
	$customPopupDiv.css("overflow", "inherit");
	$customPopupDiv.height('');

	console.warn('left1',parseInt($window.width()));
	console.warn('left2',parseInt(newWidth));
	$popupContact.css({
		top: $window.scrollTop() + ($window.height() / 2 - $popupContact.height() / 2),
		left: (parseInt($window.width()) / 2 - parseInt(newWidth) / 2),
		hyphens: 'auto'
	});

	loadPopup();

	$("#popupContact").css({
		"border-radius": "9px",
		"padding-top": "0px",
		"padding-bottom": "0px"
	});

	$(".btn-round").css({
		"border-radius": "20px"
	});

	$("#customPopupDiv h3").css({
		"font-size": "16px",
		"font-weight": "bold",
		"font-family": "ProximaNova",
		"letter-spacing": "0.5px",
		"color": "#3f4650",
		"opacity": "0.87",
		"line-height": "1.5",
		"margin-bottom": "16px"
	});

	$(".btn-div").css({
		"margin-top": "15px",
		"margin-bottom": "15px",
		"display": "inline-block"
	});
}

function customPopupContentRoundedCss() {
    var $popupContact = $("#popupContact");
    var $customPopupDiv = $("#customPopupDiv");
    $customPopupDiv.find(".cancel").css({
        "color":"#555",
        "background-color":"#eee",
        "border-color":"#eee"
    });

    $(".btn-round").css({
        "border-radius": "20px"
    });

    var $popupDivTitle = $customPopupDiv.find("h3");
    $popupDivTitle.css({
        "font-size": "16px",
        "font-weight": "bold",
        "font-family": "ProximaNovaRegular",
        "letter-spacing": "0.3px",
        "color": "#3f4650",
        "opacity": "0.87",
        "margin-bottom": "16px",
        "margin-top": "0"
    });
    $(".btn-div").css({
        "margin-top": "15px",
        "margin-bottom": "0",
        "display": "inline-block"
    });
    $popupContact.css({
        "border-radius": "9px",
        "padding-top": "0px",
        "padding-bottom": "0px",
        "padding-left": "0",
        "padding-right": "0"
    });
    $customPopupDiv.css({
        "padding": "24px 16px 16px"
	});
    if ($(window).width() < 768) {
        $popupContact.css({
            "width": "90%",
            "margin-left": "5%",
            "margin-right": "5%"
        });
    }
    if($(window).width() < 375) {
        $popupDivTitle.css({
            "font-size": "14px"
        });
    }
    if($(window).width() < 339) {
        $("#popupContact .btn").css({
            "font-size": "12px"
        });
        $("#popupContact .cancel").css({
            "width": "100px"
        });
    }
}

function customPopupContentRounded($customPopupDivName, content, newWidth, newHeight, borderRadius, title, url) {
    var $popupContact = $("#popupContact");
    $popupContact.html('<div id="' + $customPopupDivName + '" style="overflow: auto;"></div>');
    newWidth = newWidth ? newWidth : 320;
    newHeight = newHeight ? newHeight : 'auto';
    var $customPopupDiv = $("#" + $customPopupDivName);
    $customPopupDiv.html(
    	'<form action="' + url + '" style="height: auto">' +
		'<div><h3>' + title + '</h3></div>' +
		content +
		'<div class="btn-div">' +
        '    <input id="submit_btn" type="submit" class="btn btn-round btn-default disabled">' +
        '    <input type="button" value="Cancel" class="btn btn-round cancel" style="width:110px;margin-left:15px" onclick="disablePopup()">' +
        '</div>' +
		'</form>'
	);

    $popupContact.width(newWidth)
        .height(newHeight)
        .css('border-radius', borderRadius);
    $customPopupDiv.css("overflow", "inherit");
    $customPopupDiv.height('');

    var imgAmt = $customPopupDiv.find('img').length;
    if (imgAmt < 1) {
        centerPopup();
        loadPopup();
        newHeight === 'auto' && $('#popupContact, #customPopupDiv').height('auto');
    } else {
        $customPopupDiv.waitForImages(function() {
            centerPopup();
            loadPopup();
            newHeight === 'auto' && $('#popupContact, #customPopupDiv').height('auto');
        });
    }
}

function showSendMessageDialog(args) {
    var $messageModal = showReactModal(React.createElement(reactComponents.Proposal.MessageAgentModal, {
        responseId: args.quoteId,
        isBuyer: !args.seller,
        agentName: args.agentName,
        agentPhotoUrl: args.agentPhotoUrl,
        defaultMessage: args.defaultMessage,
		onDimissModal: args.onDimissModal || null,
        onMessageSent: function(quote) {
            if (args.afterMessageSent) {
                args.afterMessageSent();
            }
            if (args.hideContactStep) {
                $messageModal.modal('hide');
                $messageModal = showSimpleTextModal(
                	"Your message has been sent. " + args.agentName + " will get in touch with your shortly.");
                $messageModal.on('hidden.bs.modal', function() {
					if (!args.disablePageReload) {
                    	window.location.reload();
					}
                });
                return;
            }
            $messageModal.modal('hide');
            var $secondModal = showReactModal(React.createElement(reactComponents.Proposal.MessageAgentSuccessModal, {
                agentName: args.agentName,
                agentPhotoUrl: args.agentPhotoUrl,
                agentPhone: quote.realtor.bizPhone,
                clientUserId: quote.request.user.userId,
                clientPhone: quote.request.user.phone,
				onClickCallMeToAnotherNumber: args.onSuccessModalCallMeToAnotherNumber,
            	onChangeNumber: args.onSuccessModalChangeNumber,
            }));
			if (args.onShowSuccessModal) {
                args.onShowSuccessModal();
            }
            $secondModal.on('hidden.bs.modal', function() {
				if (!args.disablePageReload) {
					window.location.reload();
				}
            });
        }
    }));
}

function showSendMessageDialogLTK(args) {
    var $messageModal = showReactModal(React.createElement(reactComponents.Proposal.MessageAgentModal, {
        responseId: args.quoteId,
        isBuyer: !args.seller,
        agentName: args.agentName,
        agentPhotoUrl: args.agentPhotoUrl,
        defaultMessage: args.defaultMessage,
		onDimissModal: args.onDimissModal || null,
		ltk: args.ltk ? '_ltk' : '',
		ft:  args.ft  ? '_ft' : '',
		tracking: args.tracking,
		dynamicModules: args.dynamicModules,
		agentId: args.agentId,
        onMessageSent: function(quote) {
            if (args.afterMessageSent) {
                args.afterMessageSent();
            }
            if (args.hideContactStep) {
                $messageModal.modal('hide');
                $messageModal = showSimpleTextModal(
                	"Your message has been sent. " + args.agentName + " will get in touch with your shortly.");
                $messageModal.on('hidden.bs.modal', function() {
					if (!args.disablePageReload) {
                    	window.location.reload();
					}
                });
                return;
            }
            $messageModal.modal('hide');
            var $secondModal = showReactModal(React.createElement(reactComponents.Proposal.MessageAgentSuccessModal, {
                agentName: args.agentName,
                agentPhotoUrl: args.agentPhotoUrl,
                agentPhone: quote.realtor.bizPhone,
                clientUserId: quote.request.user.userId,
                clientPhone: quote.request.user.phone,
				onClickCallMeToAnotherNumber: args.onSuccessModalCallMeToAnotherNumber,
            	onChangeNumber: args.onSuccessModalChangeNumber,
				ltk: args.ltk ? '_ltk' : '',
				ft:  args.ft  ? '_ft' : '',
				tracking: args.tracking,
				dynamicModules: args.dynamicModules,
				agentId: args.agentId,
            }));
			if (args.onShowSuccessModal) {
                args.onShowSuccessModal();
            }
            $secondModal.on('hidden.bs.modal', function() {
				if (!args.disablePageReload) {
					window.location.reload();
				}
            });
        }
    }));
}

function showUnlockProposal(args) {
	trackEvent('Proposal', !!args.contact? 'incompleteSeenContactModal' :'incompleteSeenUnlockModal', !!args.contact? 'incompleteSeenContactModal' : 'incompleteSeenUnlockModal');
    var $modal = showReactModal(React.createElement(reactComponents.Proposal.ProposalUnlockModal, {
		userId: args.userId,
		requestId: args.requestId,
        responseId: args.quoteId,
        isBuyer: !args.seller,
        agentName: args.agentName,
        agentPhotoUrl: args.agentPhotoUrl,
		contact: args.contact,
		variant: args.variant,
		action: args.action,
		forceConfirmation: true,
		onFinish: function(phone) {
            $modal.on('hidden.bs.modal', function() {
                if (args.contact) {
                    args.onFinish && args.onFinish(phone);
                } else {
                    var $verifyPhoneModal = showReactModal(React.createElement(reactComponents.Proposal.VerifyPhoneModal, {
                        userId: args.userId,
						requestId: args.requestId,
						buyer: !args.seller,
                        phone: phone,
                        sendCodeOnLoad: true,
						action: args.action,
						forceConfirmation: true,
                        onSuccess: function() {
							args.onFinish && args.onFinish(phone);
							if (!args.noRedirect) {
								$verifyPhoneModal.on('hide.bs.modal', function() {
									window.location = (args.seller ? 'seller-received-quotes' : 'buyer-received-quotes')
										+ '?requestId=' + args.requestId + (args.clickInvite ? '&clickInvite=true' : '') 
										+ (args.showSuggestedAgents ? '&showSuggestedAgents=true' : '');
								});
							} else {
								window.location.reload();
							}
                        }
                    }));
                }
            }).modal('hide');
		}
    }));
}

function showRequestCallDialog(args) {
    var $messageModal = showReactModal(React.createElement(reactComponents.Proposal.RequestCallModal, {
        responseId: args.responseId,
        isBuyer: args.isBuyer,
        agentName: args.agentName,
        agentPhotoUrl: args.agentPhotoUrl,
        agentPhone: args.agentPhone,
        clientUserId: args.clientUserId,
        clientPhone: args.clientPhone,
    }));
	if (args.reloadPageOnModalClose) {
		$messageModal.on('hide.bs.modal', function() {
			window.location.reload();
		});
	}
	if (args.isAfterClientAddedPhone) {
		trackEvent('Proposal',
			args.isBuyer ? 'phonelessBuyerLandedOnContactConfirmPopup' : 'phonelessSellerLandedOnContactConfirmPopup',
			null,
			{has_landed_on_contactconfirmpopup: true}
		).withGA();
	} else {
		trackEvent('Proposal',
			args.isBuyer ? 'phonedBuyerLandedOnRequestingCallConfirmPopup' : 'phonedSellerLandedOnRequestingCallConfirmPopup',
			null,
			{has_landed_on_requestingcallconfirmpopup: true}
		).withGA();
	}
}

function showRequestCallDialogLTK(args) {
    var $messageModal = showReactModal(React.createElement(reactComponents.Proposal.RequestCallModal, {
        responseId: args.responseId,
        isBuyer: args.isBuyer,
        agentName: args.agentName,
        agentPhotoUrl: args.agentPhotoUrl,
        agentPhone: args.agentPhone,
        clientUserId: args.clientUserId,
        clientPhone: args.clientPhone,
		ltk: args.ltk,
		ft: args.ft,
		tracking: args.tracking,
		dynamicModules: args.dynamicModules,
		agentId: args.agentId
    }));
	if (args.reloadPageOnModalClose) {
		$messageModal.on('hide.bs.modal', function() {
			window.location.reload();
		});
	}
	if (args.isAfterClientAddedPhone) {
		trackEvent('Proposal',
			args.isBuyer ? 'phonelessBuyerLandedOnContactConfirmPopup' : 'phonelessSellerLandedOnContactConfirmPopup',
			null,
			{has_landed_on_contactconfirmpopup: true}
		).withGA();
	} else {
		trackEvent('Proposal',
			args.isBuyer ? 'phonedBuyerLandedOnRequestingCallConfirmPopup' : 'phonedSellerLandedOnRequestingCallConfirmPopup',
			null,
			{has_landed_on_requestingcallconfirmpopup: true}
		).withGA();
	}
}

function prettyPopupContent(content, newWidth, newHeight, onComplete, noCloseButton) {
    newWidth = newWidth ? newWidth : 320;
    newHeight = newHeight ? newHeight : 240;
    var popupContact = $("#popupContact");
	if (!noCloseButton) {
		popupContact.html('<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div>');
	}
	if ($('#customPopupDiv').length) {
		$('#customPopupDiv').remove();
	}
	popupContact.append($('<div id="customPopupDiv"/>').css({
		'padding-top': 0,
		'padding-bottom': 0
	}));
    popupContact.css({width: newWidth, 'border-radius': '5px', height: newHeight});
    $("#customPopupDiv").html(content);
    $("#customPopupDiv").height('100%');

    var imgAmt = $("#customPopupDiv").find('img').length;
    if (imgAmt < 1) {
        centerPopup(true, true);
        loadPopup(onComplete);
        newHeight === 'auto' && $('#customPopupDiv').css('height', 'auto');
        newHeight === 'auto' && $('#popupContact').css('height', 'auto');
    } else {
        $('#customPopupDiv').waitForImages(function() {
            centerPopup(true, true);
            loadPopup(onComplete);
            newHeight === 'auto' && $('#customPopupDiv').css('height', 'auto');
            newHeight === 'auto' && $('#popupContact').css('height', 'auto');
        });
    }
}

function makePopopFormSmallRedSubmitButtonResponseButtonless(){
	$('#popupSubmit').attr('class','smallredbutton');
}

function phoneFormat(obj, e, country) {
	var keyCode = ('which' in e) ? e.which : e.keyCode;
	if (keyCode !== 8 && !e.ctrlKey) {
		fieldInput = obj.value;
		obj.value = returnPhoneFormat(fieldInput, country);
	}
}

function returnPhoneFormat(val, country) {
	if (!val) {
		return null;
	}
	var numbersOnly = returnNumbersOnly(val);
	if (country == undefined || country == 'US' || country == '') {
		if (numbersOnly.length == 0) {
			phone = '';
		} else if (numbersOnly.length <= 3) {
			phone = '(' + numbersOnly.substr(0, 3);
		} else if (numbersOnly.length <= 6) {
			phone = '(' + numbersOnly.substr(0, 3) + ') ' + numbersOnly.substr(3, 3);
		} else if (numbersOnly.length > 6) {
			phone = '(' + numbersOnly.substr(0, 3) + ') ' + numbersOnly.substr(3, 3) + "-" + numbersOnly.substr(6, 4);
		}
		return phone;
	}
	return numbersOnly;
}

function returnNumbersOnly(val) {
	return val != null ? val.replace(/[^0-9]/g, '') : val;
}

function numberFormat(obj) {
	obj.value = returnNumbersOnly(obj.value);
}

function returnFloatNumbersOnly(val) {
	return val != null ? val.replace(/[^0-9.]/g, '').replace('.', 'x').replace(/\./g,'').replace('x','.') : val;
}

function formatPhoneField(obj,idx) {
	if (typeof obj[idx] != 'undefined' && obj[idx] != null) {
		obj[idx+'Numbers'] = returnNumbersOnly(obj[idx]);
		obj[idx] = returnPhoneFormat(obj[idx+'Numbers']);
	}
	return obj;
}

function formatDateField(obj,idx) {
	if (typeof obj[idx] != 'undefined' && obj[idx] != null) {
		obj[idx] = returnPrettyDate(obj[idx]);
	}
	return obj;
}

//wait for images 1.4.2
(function(e){var t="waitForImages";e.waitForImages={hasImageProperties:["backgroundImage","listStyleImage","borderImage","borderCornerImage"]},e.expr[":"].uncached=function(t){if(!e(t).is('img[src!=""]'))return!1;var n=new Image;return n.src=t.src,!n.complete},e.fn.waitForImages=function(n,r,i){var s=0,o=0;e.isPlainObject(arguments[0])&&(i=arguments[0].waitForAll,r=arguments[0].each,n=arguments[0].finished),n=n||e.noop,r=r||e.noop,i=!!i;if(!e.isFunction(n)||!e.isFunction(r))throw new TypeError("An invalid callback was supplied.");return this.each(function(){var u=e(this),a=[],f=e.waitForImages.hasImageProperties||[],l=/url\(\s*(['"]?)(.*?)\1\s*\)/g;i?u.find("*").andSelf().each(function(){var t=e(this);t.is("img:uncached")&&a.push({src:t.attr("src"),element:t[0]}),e.each(f,function(e,n){var r=t.css(n),i;if(!r)return!0;while(i=l.exec(r))a.push({src:i[2],element:t[0]})})}):u.find("img:uncached").each(function(){a.push({src:this.src,element:this})}),s=a.length,o=0,s===0&&n.call(u[0]),e.each(a,function(i,a){var f=new Image;e(f).bind("load."+t+" error."+t,function(e){o++,r.call(a.element,o,s,e.type=="load");if(o==s)return n.call(u[0]),!1}),f.src=a.src})})}})(jQuery);

function getElementsByClassName(className) {
	if (document.getElementsByClassName) {
		return document.getElementsByClassName(className);
	}
	else {
		// IE8
		return $('.' + className);
	}
}

// Custom play stopbuttons for voice proposal
var state = 'stop';
function buttonPlayPress(e) {
	var self = $(this);
	var audio;
	var targetAudioId = self.data('target-audio');
	if (targetAudioId) {
		audio = $('#' + targetAudioId)[0];
	} else {
		var parent = self.closest('.voiceContainer');
		audio = parent.find('#embeddedAudio')[0];
	}
	var state = audio.playState || "stop";
	var i = self.find('i');
	var span = self.find('span');
	if (state=='stop' || state=='pause'){
		state='play';
		i.attr('class', "fa fa-pause");
		span.html('Pause');
		audio.play();
	} else {
		state='pause';
		i.attr('class', "fa fa-play");
		span.html('Play');
		audio.play();
        audio.pause();
	}
	audio.playState = state;
}

function buttonReplayPress(e) {
	var self = $(this);
	var parent = self.closest('.voiceContainer');
	var audio;
	var targetAudioId = self.data('target-audio');
	if (targetAudioId) {
		audio = $('#' + targetAudioId)[0];
	} else {
		audio = parent.find('#embeddedAudio')[0];
	}
	var playButton = parent.find('.button_play');
    var i = playButton.find('i');
	var span = playButton.find('span');
	i.attr('class', "fa fa-pause");
	span.html('Pause');
    audio.load();
	audio.pause();
	audio.currentTime = 0;
	audio.play();
	audio.playState ="play";
}

function bindPlayerActions() {
	$(document).on('click', '.button_play', buttonPlayPress);
	$(document).on('click', '.button_replay', buttonReplayPress);
}

// Cookie controlled popup model

function getFeaturedCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length == 2)
        return parts
            .pop()
            .split(';')
            .shift();
}

function setFeaturedCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + '; ' + expires;
}

function cookiefiedPopup(cookieName, func, expTime) {
    var x = getFeaturedCookie(cookieName);
    if (x == '' || x == null) {
        func();
        setFeaturedCookie(cookieName, cookieName, expTime);
    }
}

function ifNoCookie(cookieName, expTime) {
    return {
        then: function(callback) {
            var cookieValue = getFeaturedCookie(cookieName);
            if (!cookieValue) {
                callback();
                setFeaturedCookie(cookieName, cookieName, expTime);
            }
        }
    };
}

// function for us to delete browser cookies by name for testing purposes
function deleteBrowserCookieByName( name ) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

//New Features Advertising Popup
function showNewFeatures(obj) {
    var content = hb.templates.newFeaturesPopup(obj);
    customPopupContent(content, 500, 315);
}

//Announcement banner
function showAnnouncementBanner(obj){
    var selector = $('.'+ obj.tag);
    var templateName = obj.templateName;
    selector.prepend(hb.templates[templateName](obj));
    var deferred = $.Deferred();
    $('.alert-info-original').slideDown('slow', function() {
        deferred.resolve();
    });
	$('.alert-msg-close').on('click', function () {
		$('.alert-info-original').remove();
        setFeaturedCookie(obj.campaign, obj.campaign, obj.expTime);
	});
	$('.alert-msg-link').on('click', function () {
		$('.alert-info-original').remove();
        setFeaturedCookie(obj.campaign, obj.campaign, obj.expTime);
		if(obj.url){
			window.open(obj.url, '_blank');
		}
	});
	return deferred.promise();
}

// Click button copy to cilboard
function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text() || $(element).val()).select();
    document.execCommand("copy");
    $temp.remove();
}

// global variables for admin comment filter
var adminCommentSortDesc = true;
var filterIsLoading = false;

// toggle admin comment filter spinner
function toggleFilterSpinner(id) {
    $('.panel-'+id+' .filterIsLoading').toggle();
}

// toggle admin comment filter class
function toggleFilterClass(id, name) {
    str = name.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
	});
	if (str === 'Asc'|| str==='Desc') {
		str = 'All'
	}
	var $items = $('.panel-'+id+' .panel-filter-item');
	$items.add($items.find('a')).removeClass('active');
	var $activeItem = $items.filter(function() {
		return $(this).find('a').text().toLowerCase().startsWith(str.toLowerCase());
	});
	$activeItem.addClass('active');
	$activeItem.find('a').addClass('active');
}

// toggle sort arrow
function toggleSortArrow(id, name) {
    var up = $('.panel-'+id+' .ac-sort-arrow-up');
    var down = $('.panel-'+id+' .ac-sort-arrow-down');
    if (name == 'desc' || name == 'asc') {
        if (down.is(':visible')) {
            down.hide();
            up.show();
        } else {
            down.show();
            up.hide();
        }
    } else {
        down.show();
        up.hide();
     }
}

//User Profile add Request Reminder

function addReminder(requestId, reminderNote, isBuyer) {
	//var i = reminderNote.indexOf('[');
	//if (i > 1) {
	//		reminderNote = reminderNote.substring(0,i-1);
	//}
	var reminderform =
	'<textarea name="reminderNote" id="reminder-textarea" rows="2" cols="50" maxlength="2000" class="reminder forminput">'+reminderNote+'</textarea> <p id="characterCount"></p>';
	if (isBuyer) {
		customPopupForm('Save Reminder', 'addReminderNoteBuyReq-json?requestId='+requestId, 'Edit Request Reminder', '320', 'auto', reminderform); ajaxThis('note', true);
	} else {
		customPopupForm('Save Reminder', 'addReminderNoteReq-json?requestId='+requestId, 'Edit Request Reminder', '320', 'auto', reminderform); ajaxThis('note');
	}

	// CHARACTER COUNT SECTION
	var textarea = $("#reminder-textarea");
	var characterCountElement = $("#characterCount");
	if (characterCountElement) {
		var characterCount = textarea && textarea.length > 0 ? textarea.val().length : 0;
		characterCountElement.text(characterCount + "/2000");
		textarea.on("input change", function () {
			var currentCharacterCount = textarea.val().length;
			characterCountElement.text(currentCharacterCount + "/2000");
		});
	}
}

//Agent Profile add Response Reminder

function addResponseReminder(quoteId, reminderNote, isBuyer) {
	var reminderform =
	'<input name="reminderNote" maxlength="150" class="reminder forminput" value="'+reminderNote+'"></input>';
	if (isBuyer) {
		customPopupForm('Save Reminder', 'addReminderNoteBuyQuote-json?quoteId='+quoteId, 'Edit Response Reminder', '320', 'auto', reminderform);ajaxThis('note', true);
	} else {
		customPopupForm('Save Reminder', 'addReminderNoteQuote-json?quoteId='+quoteId, 'Edit Response Reminder', '320', 'auto', reminderform); ajaxThis('note');
	}
    $('#popupForm').submit(function(e) {
        e.preventDefault();
        var formData = $(this).serialize();
        $.post(this.action, formData).then(function(data) {
            $(this).modal('hide');
            if (data.msg) {
                defaultAjaxError(data.msg);
            }
        });
    });
}
function updateAgentProfile(quoteId, isBuyer) {
	var detailsUrl = isBuyer? 'getBuyQuoteAgentDetails-json' : 'getQuoteAgentDetails-json';
	var detailsPromise = $.get(detailsUrl, {quoteId: quoteId}).then(function(data) {
		if (!checkAjax(data)) {
			return;
		}
		var agentProfile = $('main section.mainDetails .details .CTA .agentProfile ');
		if (isBuyer) {
			agentProfile.replaceWith(hb.templates.details.agentProfile(data.quote));
		} else {
			agentProfile.replaceWith(hb.templates.details.agentProfile(data.quote));
		}
	});
}

function getMetadataObject(metadata) {
	var obj = {};
	if (!metadata) return null;

 	var pair = metadata.split(';');

	for(curr in pair) {
			var key = pair[curr].split('=')[0];
			var value = pair[curr].split('=')[1];
			obj[key] = value;
	}
	return obj;
}

function filterAdminComments(requestId, filter, buy, sort, user) {
    if (filterIsLoading) {
        return;
    }

    filterIsLoading = true;
    if (sort) {
        filter = adminCommentSortDesc ? 'desc' : 'asc';
        adminCommentSortDesc = !adminCommentSortDesc;
    }
    toggleFilterSpinner(requestId);
    toggleFilterClass(requestId, filter);
    toggleSortArrow(requestId, filter);

    $.getJSON('filterComment-json', {requestId: requestId, filter: filter, buy: buy})
        .done(function(data) {
            $('.panel-' + requestId + ' .adminCommentList li').remove();
            $('.conversationnn ').remove();
            var $commentList = $('.panel-' + requestId + ' .adminCommentList');
            var commentHtml;
            if (checkAjax(data)) {
                $.each(data, function(i, comment) {
                    var typeStr = comment.typeStr || '';
                    var subType = comment.subType || '';
                    var name = comment.logger.name || '';
                    var avatarUrl = comment.logger.avatar_url || '';
                    var dateStr = comment.dateStr || '';
                    var commentText = comment.comment || '';
                    commentText = commentText.replace(/\</g,"&lt;");
                    var metadata = getMetadataObject(comment.metadata);
                    var commentData = {
                        commentId: comment.commentId,
                        logger: {
                            name: name,
                            avatar_url:  avatarUrl,
                            admin: comment.logger.admin,
                            buyer: comment.logger.buyer,
                            userAgent: comment.logger.userAgent,
                            seller: comment.logger.seller,
                        },
                        metadata: metadata,
                        type: comment.type || '',
                        dateStr: dateStr,
                        typeStr: typeStr,
                        subType: subType,
                        comment: commentText
                    };

                    if (filter != 'sms') {
                        commentHtml = hb.templates.details[global.isAdmin? 'adminNoteCard' : 'adminCommentSection'](commentData);
                        //commentHtml =$(hb.templates.details['adminCommentSection'](commentData));
                        $(commentHtml).appendTo($commentList);
                    } else {

                        if (global.isAdmin) {
                            commentHtml = $('<div></div>').css({
                                'margin-left': '-24px',
                                'margin-right': '-24px'
                            });
                            $(commentHtml).appendTo($commentList);
                        } else {
                            commentHtml = hb.templates.details['adminCommentSection'](commentData);
                            //commentHtml =$(hb.templates.details['adminCommentSection'](commentData));
                            $(commentHtml).appendTo($commentList);
                        }
                    }
                    //var commentHtml = hb.templates.details[global.isAdmin? 'adminNoteCard' : 'adminCommentSection'](commentData);

                });
                if (global.isAdmin && filter=== 'sms') {
                    var container = commentHtml[0];
                    var activity = {
                        clientName: user.name,
                        formattedType: buy? "buyer" : "seller",
                        toNumber: user.phone,
                        state: user.state,
                        city: user.city,
                        requestId: requestId,
                        propertyLocation: user.city + ',' + user.state,
                        clientType: buy? "buy" : "sell",
                        isbuer: buy,
                    };
                    ReactDOM.render(
                        React.createElement(
                            reactComponents.Conversation,
                            {
                                activity: activity,
                                dataItems: data,
                            },
                            null
                        ),
                        container
                    );
                }

            }
            $('.allNotes .panel.panel-primary').hide();
            filterIsLoading = false;
            toggleFilterSpinner(requestId);
        })
        .error(function() {
            filterIsLoading = false;
            toggleFilterSpinner(requestId);
            defaultAjaxError();
        });
}

// search youtube api
var ytArr = [];
var videoSuggestions = {};
function fetchYoutubeVideos(name, brokerage, id) {
	var request = gapi.client.youtube.search.list({
			q: name + brokerage,
			type: 'video',
			part: 'snippet',
			regionCode: 'US',
			safeSearch: 'strict',
			 maxResults: 3
		  });
	request.execute(function(response) {
	  var str = response.result;
	  if (!!str && !!str.items) {
		str.items.forEach(function(i){
			ytArr.push({
				videoId: i.id.videoId,
				title:  i.snippet.title
			});
		});
	  }
	});
	videoSuggestions = {realtorId: id, ytArr: ytArr};
}

function realtorYoutubeSearch(name, brokerage, id) {
	gapi.client.setApiKey(global.googleGeocodingUrl);
	gapi.client.load('youtube', 'v3').then(function(){fetchYoutubeVideos(name, brokerage, id);});
}

function toggleYtCheckBoxes(){
   $('input.ytcheckbox_check').on('change', function() {
		$('input.ytcheckbox_check').not(this).prop('checked', false);
		$('#virtualTourUrl').val('https://www.youtube.com/watch?v=' + $(this).siblings().val());
	});
}

function toggleYtDelete(yt){
		if($("input.yt-delete-box").is(':checked')){
            $('#virtualTourUrl').removeAttr('required').val('');
			$('#updateDeletYt').val('Delete').removeClass('btn-default').addClass('btn-danger');
			$('.ytIframe > iframe').slideToggle();
        }else {
            $('#virtualTourUrl').val(yt).attr('required');
			$('#updateDeletYt').val('Update').removeClass('btn-danger').addClass('btn-default');
			$('.ytIframe > iframe').slideToggle();
        }
}

// buyer rebate popup functions
function buyerRebatePopUp(obj) {
    obj.agentCommission = (obj.highRange / 100) * 3;
 	obj.buyerPercentRate = obj.buyerAmt / (obj.agentCommission / 100);
	obj.agentPercentRate  = 100 - obj.buyerPercentRate;
	obj.agentSplit = (obj.agentCommission / 100) * obj.agentPercentRate;
	obj.agentPercentRateStr = formatRebateAmts(Math.round(obj.agentPercentRate));
	obj.buyerPercentRateStr = formatRebateAmts(Math.round(obj.buyerPercentRate));
	obj.buyerAmtStr = formatRebateAmts(obj.buyerAmt);
	obj.estSavingAmtStr = formatRebateAmts(obj.buyerAmt + 150);
	obj.agentCommissionStr = formatRebateAmts(obj.agentCommission);
	obj.homePriceStr = formatRebateAmts(obj.highRange);
	obj.agentSplitStr = formatRebateAmts(obj.agentSplit);

	var content = hb.templates.buyerFlow.buyerRebatePopup(obj);
	customPopupContent(content, 460, 340);

    ga('send', 'event', 'Flow', 'buyerClickLearnMore');
	mixpanel.track('buyerClickLearnMore');
	mixpanel.people.set({'lastEvent': 'buyerClickLearnMore','userType':userType});
}

function formatRebateAmts(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function startChat() {;
	if (window.fcWidget) {
		window.fcWidget.open();
	}
}

function playVideoTutorial(ytId, trckEvt){
	var href = 'https://www.youtube.com/embed/'+ytId+'?rel=0&amp;showinfo=0&autoplay=1';
	initYT(href, 900, 500);

    ga('send', 'event', 'Flow', 'buyerClickLearnMore');
	mixpanel.track(trckEvt);
	mixpanel.people.set({'lastEvent': trckEvt,'userType':userType});
	window.optimizely.push(["trackEvent", trckEvt]);
}

function showRecentTransactionsSection(el) {
		$(el).show();
}

$(document).ready(function(){

	$('.content #request').on('click',bindPlayerActions);
	 bindPlayerActions();

if (document.getElementById('mobileMenu') == undefined) {//do not expand for mobile
	$("#stylefour .expandable").on('mouseover',function() {
		$(".expandable").addClass('mainnavhover');
		$("#loggedinmenu").show();
	});
	$("#stylefour .expandable").on('mouseout',function() {
		$(".expandable").removeClass('mainnavhover');
		$("#loggedinmenu").hide();
	});

	$("#wrappmid, #banner, .content, .secondarycontent").on('click',function() {
		$("#stylefour .dropdown").removeClass('mainnavhover');
		$("#stylefour .dropdown").children("ul.mainnavhover").hide();
		$(".expandable").removeClass('mainnavhover');
		$("#loggedinmenu").hide();
	});

	var iPadDelayActive = false;
	$("#stylefour .dropdown").on('mouseover',function(evt) {
		if(navigator.userAgent.match(/iPad/i)) {
			obj = $(this);
			if (iPadDelayActive) {
				if (typeof(evt.target.href) == "string") {
					window.location.href = evt.target.href;
				}
			} else {
				iPadDelayActive = true;
				setTimeout(function() {
					window.location.href = obj.children('a').attr('href');
				},2000);
			}
		}
		$("#stylefour .dropdown").removeClass('mainnavhover');
		$("#stylefour .dropdown").children("ul.mainnavhover").hide();
		$(this).addClass('mainnavhover');
		$(this).children("ul.mainnavhover").show();
	});
	$("#stylefour .dropdown").on('mouseout',function() {
		$(this).removeClass('mainnavhover');
		$(this).children("ul.mainnavhover").hide();
	});
}

$("#backgroundPopup").click(function(){
	disablePopup();
});
$(document).keypress(function(e){
	if (e.keyCode == 27) {
		if (popupStatus == 1) {
			disablePopup();
		}
	}
});
$("#loginid").click(function(){
	window.location.href = "login";
});
$("#registerid").click(function(){
	window.location.href = "register";
});
$("#logoutid").click(function(){
	window.location.href = "logout";
});
/* wtf is this
var list = getElementsByClassName('mapdiv');
for (var i = 0; i < list.length; i++) {
	var divid = list[i].getAttribute("id");
	if (divid != undefined) {
		var idx = 'mapdiv_'.length;
	var id = divid.substring(idx);
		initialize(id);
	}
}
*/
$(".badgeitem").mouseenter(function() {
	var badgeId = $(this).attr("rel2");
	var badgeCount = $(this).attr("rel");
	if ($("#badgeHolder").html() == '') {
		$("#badgeHolder").load(location.protocol+"//"+location.hostname+location.pathname.substr(0, location.pathname.indexOf("/",1)+1)+'badgelist.html', function(){showBadge(badgeId, badgeCount);});
	} else {
		showBadge(badgeId, badgeCount);
	}
	$("#badge-"+$(this).attr("rel")).fadeIn();
});

$(".badgeitem").mouseleave(function() {
	$("#badge-"+$(this).attr("rel")).fadeOut('fast');
});


//Show hide the Zestimate Graph
//zestimateGraph();

//custom scrollbar
// $(".mainList").customScrollbar({
//   	fixedThumbHeight: 56
// });
	var requestId = getUrlParameter('requestId');
	var showSendDemandPopup = getUrlParameter('showSendDemandPopup');
	var buyer = getUrlParameter('buyer');
	var showPopupSendDemand =  requestId && showSendDemandPopup && buyer;

	if (showPopupSendDemand) {
		showSendDemandModal(requestId, buyer);
	}
});

function showBadge(badgeId, badgeCount) {
var newBadge = badgeId.replace(".png","");
newBadge = newBadge.replace("+","");
var readMore = '<div><a href="badgelist" target="_blank">Read More</a></div>';
$("#badge-"+badgeCount+" .badgebubble").html($("#"+newBadge).html()+readMore);
}

jQuery(function() {
jQuery.support.placeholder = false;
test = document.createElement('input');
if ('placeholder' in test) jQuery.support.placeholder = true;
initPlaceholders();
});

function addPlaceholder(formId) {
$('#'+formId).find(':text, textarea').each(function() {
	if ($(this).attr('placeholder') != '' && $(this).attr('placeholder') != undefined && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder'))) {
		$(this).val($(this).attr('placeholder'));
		$(this).addClass('hasPlaceholder');
	}
});
}

function invalidPlaceholders(formId) {
	var placeholders = $('#'+formId).find('.hasPlaceholder');
	if (placeholders.length > 0) {
		$('#'+formId).find('.hasPlaceholder').each(function() {
			$(this).val('');
			$(this).removeClass('hasPlaceholder');
		});
		if ($('#'+formId).validate().form()) {
			$('#'+formId).submit();
		} else {
			addPlaceholder(formId);
		}
	}
}

function checkAjax(data, errorCall) {

    if (typeof data.status == 'number') {

        switch (data.status) {
            case 401:
                window.location = 'login';
                return false;
        }
    }
    if (data == null || data === '' || typeof data === 'string') {
        typeof errorCall == "undefined" ? defaultAjaxError() : errorCall(data);
        return false;
    } else if (typeof data.redirectUrl == 'string') {
        window.location = data.redirectUrl;
        return false;
    } else if (typeof data.msg == 'string') {
        if (data.msg.startsWith('__SHOW_ACCOUNTING_MODAL__')) {
            var actualMessage = data.msg.replace('__SHOW_ACCOUNTING_MODAL__', '');
            showAwardedDateMissingModal(actualMessage);
            return false;
        }

        typeof errorCall == "undefined" ? defaultAjaxError(data.msg) : errorCall(data.msg);
        return false;
    } else {
        return true;
    }
}

function showAwardedDateMissingModal(message) {
    var content =
        '<div class="date-validation-error">' +
        '<h1 style="margin-top:0">Date Validation Error</h1>' +
        '<p>' + message + '</p>' +
        '<div style="text-align: center; margin-top: 20px;">' +
        '<button type="button" id="openAccountingBtn" class="btn btn-primary" style="margin-right: 10px;">Open Accounting</button>' +
        '<button type="button" id="cancelBtn" class="btn btn-default">Cancel</button>' +
        '</div>' +
        '</div>';

    var popup = customPopupContent(content, 400, 'auto');


    $('#openAccountingBtn').click(function(e) {
        e.preventDefault();


        disablePopup();

        var requestId = getParameterByName('requestId');

        setTimeout(function() {
            var request = pagination.getCurrentRequest(requestId);

            if (request) {
                showSellAccountingPopup(
                    requestId,
                    request.soldDateMMDDYY || '',
                    request.soldPrice || '',
                    request.listDateMMDDYY || '',
                    request.listPrice || '',
                    request.wonAgent || '',
                    request.finalComm || '',
                    request.referralFee || '',
                    request.collectedAmount || '',
                    request.concessionAmount || '',
                    request.listingAgreement || '',
                    request.awardedDateMMDDYY || '',
                    request.sellPct || '',
                    request.agreementUrl || '',
                    request.rentReferral || '',
                    request.zestimate || '',
                    request.delinquent || false
                );
            } else {
                $.ajax({
                    url: 'getRequestByRequestId-json',
                    data: { requestId: requestId },
                    success: function(data) {
                        if (!checkAjax(data)) return;

                        showSellAccountingPopup(
                            requestId,
                            data.soldDateMMDDYY || '',
                            data.soldPrice || '',
                            data.listDateMMDDYY || '',
                            data.listPrice || '',
                            data.wonAgent || '',
                            data.finalComm || '',
                            data.referralFee || '',
                            data.collectedAmount || '',
                            data.concessionAmount || '',
                            data.listingAgreement || '',
                            data.awardedDateMMDDYY || '',
                            data.sellPct || '',
                            data.agreementUrl || '',
                            data.rentReferral || '',
                            data.zestimate || '',
                            data.delinquent || false
                        );
                    }
                });
            }
        }, 300);
    });

    $('#cancelBtn').click(function(e) {
        e.preventDefault();
        disablePopup();
    });
}

function defaultAjaxError(errorMsg) {
    errorMsg = typeof errorMsg == "string" ? errorMsg : "Sorry, there was an error.<br/>Please try again or contact our chat support.";
	disablePopup();
    showSimpleTextModal({text: errorMsg, textAlign: 'center'});
}

function checkAndValidateLicense() {

var name = $('#name').val();
if (name == '') {
	$('#name').focus();
	return;
}

var license = $('#licenseNum').val();
if (license == '') {
	$('#licenseNum').focus();
	return;
}

var h_state = $('#h_state').val();
var h_brokerage = $('#h_brokerage').val();

$('#licenseNumContainer span').remove();
$('#licenseNumContainer').append('<span><br />Checking license date ... <img src="//www.lt6p.com/re/img/stupeflix/spinner.gif" style="height:1em;vertical-align:text-bottom"/></span>');
// Make all ajax calls timeout in 15 seconds.
$.ajaxSetup({ timeout: 30000 });
$.getJSON(
		'fetchLicenseSince',
		{'name': name, 'licenseNum': license, 'state':h_state, 'brokerage':h_brokerage, 'json': true},
		function (data, textStatus, jqXHR) {
			if (data != null && data.licenseSinceDate != null && data.licenseSinceDate != '') {
				$('#licenseNumContainer span').remove();
				$('#licenseNumContainer').append('<span><br />Licensed since '+data.licenseSinceDate+'</span>');
				$('#license').attr('value', license);
				if (data.agentDate != '') {
					$('#agentDate').attr('value', data.agentDate);
				}
				if (data.brokerDate != '') {
					$('#brokerDate').attr('value', data.brokerDate);
				}
			} else {
				$('#license').attr('value', '');
				$('#agentDate').attr('value', '');
				$('#brokerDate').attr('value', '');
				$('#licenseNumContainer span').remove();
				$('#licenseNumContainer').append('<span><br />We were unable to fetch your license date from the Department of Real Estate. Please double-check and try again. Please contact support with your license date if you continue to have a problem.</span>');
			}
		});
}

function postToUserWall() {
	var wallMsg = $('#wallMsg').val();

	$('#wallPostContainer span').remove();
	$('#wallPostContainer').append('<span><br/>Sharing this on your profile...</span>');
	$.getJSON(
			'postToUserWall',
			{'wallMsg': wallMsg},
			function (data, textStatus, jqXHR) {
				$('#wallPostContainer span').remove();
				if (data != null && data.status != null && data.status == 'OK') {
					$('#wallPostContainer').append('<span><br/>Thank you for sharing this on your ' + data.provider + ' profile.</span>');
				} else {
					$('#wallPostContainer').append('<span><br/>Sorry, we are not unable to share this on your profile.</span>');
				}
	});
}

var languages =	[
	'',
    'Arabic',
    'Armenian',
    'Cambodian',
    'Chinese',
    'Farsi',
    'French',
    'German',
    'Greek',
    'Hebrew',
    'Hindi',
    'Italian',
    'Japanese',
    'Korean',
    'Persian',
    'Polish',
    'Portuguese',
    'Russian',
    'Sign Language',
    'Spanish',
    'Tagalog',
    'Thai',
    'Vietnamese'
];

function degToRad(deg) {
	return deg * Math.PI / 180;
}

function calculateDistanceBetweenCoords(loc1, loc2) {
	var R = 6371; // km
	var dLat = degToRad(loc2.lat - loc1.lat);
	var dLon = degToRad(loc2.lon - loc1.lon);
	var lat1 = degToRad(loc1.lat);
	var lat2 = degToRad(loc2.lat);

	var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
	        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
	var d = R * c;
	return d;
}
var San_Francisco_Coords = { lat: 37.77493, lon: -122.41942 };
var Seattle_Coords = { lat: 47.6097, lon: -122.3331 };
var Los_Angeles_Coords = { lat: 34.05223, lon: -118.24368 };
var San_Diego_Coords = { lat: 32.72888, lon: -117.03186 };
var Boston_Coords = { lat: 42.35670, lon: -71.05690 };
var Florida_Coords = { lat: 28.4685, lon: -81.4554 };
var Washington_DC_Coords = { lat: 38.92056, lon: -77.06580 };
var San_Jose_Coords = { lat: 37.333333, lon: -121.9 };
var Sacramento_Coords = { lat: 38.555556, lon: -121.468889 };
var New_York_Coords = { lat: 40.7127, lon: -74.0059 };
var Miami_Coords = { lat: 25.787676, lon: -80.224145 };
var Alameda_Coords = { lat: 37.804444, lon: -122.270833 };
var Austin_Coords = { lat: 30.25, lon: -97.75 };
var Chicago_Coords = { lat: 41.836944, lon: -87.684722 };
var Danville_Coords = { lat: 37.821667, lon: -122 };
var Denver_Coords = { lat: 39.76185, lon: -104.881105 };
var Phoenix_Coords = { lat: 33.45, lon: -112.066667 };
var Portland_Coords = { lat: 45.52, lon: -122.681944 };
var Texas_Coords = { lat: 31.86, lon: -98.57 };

function getDefaultBounds(curCity) {
	if (curCity == "LA") {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(33.59,-118.81),
			new google.maps.LatLng(34.32,-117.24)
		);
	} else if (curCity == "SD") {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(32.53,-117.43),
			new google.maps.LatLng(33.11,-116.72)
		);
	} else if (curCity == "Seattle") {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(47.46, -122.64),
			new google.maps.LatLng(47.76, -121.98)
		);
	} else {
		return new google.maps.LatLngBounds(
			new google.maps.LatLng(37.70, -122.52),
			new google.maps.LatLng(37.82, -122.35)
		);
	}
}

function getGeoCity(myLoc) {
	var geoCity = "All";
	var distanceSF = calculateDistanceBetweenCoords(myLoc, San_Francisco_Coords);
	var distanceLA = calculateDistanceBetweenCoords(myLoc, Los_Angeles_Coords);
	var distanceSD = calculateDistanceBetweenCoords(myLoc, San_Diego_Coords);
	var distanceST = calculateDistanceBetweenCoords(myLoc, Seattle_Coords);
	var distanceSJ = calculateDistanceBetweenCoords(myLoc, San_Jose_Coords);
	var distanceSO = calculateDistanceBetweenCoords(myLoc, Sacramento_Coords);
	var distanceNY = calculateDistanceBetweenCoords(myLoc, New_York_Coords);
	var distanceDC = calculateDistanceBetweenCoords(myLoc, Washington_DC_Coords);
	var distanceBM = calculateDistanceBetweenCoords(myLoc, Boston_Coords);
	var distanceMI = calculateDistanceBetweenCoords(myLoc, Miami_Coords);
	var distanceAL = calculateDistanceBetweenCoords(myLoc, Alameda_Coords);
	var distanceAU = calculateDistanceBetweenCoords(myLoc, Austin_Coords);
	var distanceCH = calculateDistanceBetweenCoords(myLoc, Chicago_Coords);
	var distanceDA = calculateDistanceBetweenCoords(myLoc, Danville_Coords);
	var distanceDV = calculateDistanceBetweenCoords(myLoc, Denver_Coords);
	var distanceAZ = calculateDistanceBetweenCoords(myLoc, Phoenix_Coords);
	var distancePD = calculateDistanceBetweenCoords(myLoc, Portland_Coords);
	var min = closeEnough = 100.00; // In Miles
	var distance = {
		'SF':distanceSF,
		'LA':distanceLA,
		'SD':distanceSD,
		'KI':distanceST,
		'SJ':distanceSJ,
		'SO':distanceSO,
		'NY':distanceNY,
		'DC':distanceDC,
		'BM':distanceBM,
		'AL':distanceAL,
		'AU':distanceAU,
		'CH':distanceCH,
		'DA':distanceDA,
		'DV':distanceDV,
		'AZ':distanceAZ,
		'PD':distancePD
	};
	var sortable = [];
	for (var city in distance) {
		sortable.push([city,distance[city]]);
		sortable.sort(function(a,b) {
			return a[1] - b[1];
		});
	}
	if (sortable[0][1] < closeEnough) {
		geoCity = sortable[0][0];
		min = sortable[0][1];
	}
	return geoCity;
}

function updateDetails(obj) {
	var $details = $(obj).next('.details.mobile');
	var $desktopDetails = $('.details.desktop');

	if ($desktopDetails.is(':visible')) {
		$('.mainDetails').trigger('renderDetails');
		$desktopDetails.html($details.html());

		// Kixie button fix
		var $kixieButtons = $details.find('.__dt');
		var $desktopKixieButtons = $desktopDetails.find('.__dt');
		$desktopKixieButtons.each(function(index, item) {
			var originalItem = $kixieButtons.get(index);
			if (originalItem) {
				$(item).replaceWith(originalItem);
			}
		});
	}

	setTimeout(function() {
		initBubbletips();
	}, 500);

	$('.allNotes .panel.panel-primary').hide();
	$('.smallAdminNotes').show();

	showTwoAdminCommentOnLoad();
}

var timesRun = 0;

function kixieCb() {
	console.log("clicked");
	$temp = $(this).parentsUntil(".item-phone");
	$(this).off("click", kixieCb);
	$kixieData = $temp.filter(".kixieData");
	if ($kixieData.length) {
		var reqParams = $kixieData[0].dataset;
		logCallInitiation(reqParams);
	}
}

function bindEventToKixie() {
	if(window.location.pathname == '/re/listRequest'){
		console.log("Checking kixie to load: "+timesRun+" time");
		if (timesRun > 5 || $('.kixie-click-image-bind').length) {
			clearInterval(kixExistCondition);
			clearInterval(kixExistCondition1);
			timesRun = 0;
		}
		//    doTheRestOfTheStuff
		if ($('.kixie-click-image-bind').length) {
			console.log("Binding click to Kixie!");
			var reqId = $('.preview.adminList.status3.active').data("request-id");
			var selectorCls = $('.details.mobile').is(":visible")?'.details.mobile':'.details.desktop'+" .kixieData[data-requestid='"+reqId+"']";
			console.log(selectorCls);
			if($(selectorCls).find(".kixie-click-image-bind").is(":visible")){
				$(selectorCls).find(".kixie-click-image-bind").off("click", kixieCb);
				$(selectorCls).find(".kixie-click-image-bind").on("click", kixieCb);
				// $(".kixie-click-image-bind").on("click", kixieCb);
			}
		}
		timesRun++;	
	}
}
function logCallInitiation(reqParams){
	var url = 'logKixieCallInitiation';
	// var data = $.extend(reqParams, {fromAdmin: global.currentUserId});
	var data = {
		requestId: reqParams.requestid,
		isBuyer: reqParams.isbuyer && (reqParams.isbuyer == "true")? true : false,
		adminId: global.currentUserId
	}
	$.ajax({
		url: url,
		type: "POST",
		data: data
	});
}

var kixExistCondition = setInterval(bindEventToKixie, 2000);
var kixExistCondition1;
var yonyxIntervalID;
var yonyxAttemps = 0;

function openYonyxSidePanel() {
	console.log("Opening Yonyx Side Panel: " +  yonyxAttemps + " attempts");
	var openYonyxSidePanelEl = document.getElementById('openYonyxSidePanel');
	if (openYonyxSidePanelEl) openYonyxSidePanelEl.click();	
}

function endYonyxSidePanel() {
	var endYonyxIncidentEl = document.getElementById("endYonyxIncident");
	if (endYonyxIncidentEl) endYonyxIncidentEl.click();
}

function clearYonyxInterval() {
	yonyxAttemps = 0;
	if (yonyxIntervalID != null) clearInterval(yonyxIntervalID);
}

function refreshYonyxWidgetData(initialLoad){
	if (initialLoad) {		
		yonyxIntervalID = setInterval(function(){
			yonyxAttemps++;	
			if (document.getElementById("openYonyxSidePanel") || yonyxAttemps >= 20) {
				clearYonyxInterval();
				setTimeout(function(){
					openYonyxSidePanel();
				}, 1000);
			}
		}, 500);
	} else {
		clearYonyxInterval();
		endYonyxSidePanel();
		setTimeout(function(){
			openYonyxSidePanel();
		}, 500);	
	}
}

function getDetail(obj, options, isNotePopupShow) {
	if(isNotePopupShow){
		$('#min-dial-popup').remove();
	}
	
	if($('#admin-notes-popup').length){
		$('#admin-notes-popup').remove();
	}

	if ($('.details.active').parent().attr('id') == $(obj).parent().attr('id') && !$('.details.desktop').is(':visible')) {
		// Mobile
		if ($('.details.active').is(':visible')) {
			$('.details.active').slideUp();
			$('.preview.active').removeClass('active');
		} else {
			$('.details.active').slideDown();
			$(obj).addClass('active');
		}
	} else {
		// Desktop
		if ($('.details.desktop').is(':visible')) {
			$('.details.desktop').scrollTop(0);
		} else {
			$('.details.active').slideUp();
		}
		$('.details.active').removeClass('active');
		$('.preview.active').removeClass('active');
		$(obj).next('.details.mobile').addClass('active');
		$(obj).addClass('active');
		if (!$('.details.desktop').is(':visible')) {
			$(obj).next('.details.mobile').hide();
			$(obj).next('.details.mobile').slideDown();
		}
	}

	// auto popup decline, if click decline from email
	var query = window.location.search.substring(1);
	var hasEmailDecline = query.split('&').indexOf('emailDecline=emailDecline') !== -1;
	if (hasEmailDecline) {
		$('.btn.btn-gray-light.btn-lg.decline:visible').click();
	}

	updateDetails(obj, options);

	if (pagination.objType === 'request') {
		var requestId = $(obj).data('request-id');
		if (requestId) {
			var loadingSpinner = $('.mainDetails .loadingSpinner').show();
			pagination.currentRequestId = requestId;
			fetchRequestDetails(requestId).always(function() {
				if (pagination.currentRequestId == requestId) {
					loadingSpinner.hide();
					updateDetails($('#request' + requestId + ' .preview'));
					initAdminMenuV2('main.container .details.desktop');
				}
			});
		}
	} else if (pagination.objType == 'quote') {
		var responseId = $(obj).data('response-id');
		if (responseId) {
			var loadingSpinner = $('.mainDetails .loadingSpinner').show();
			pagination.currentResponseId = responseId;
			fetchResponseDetails(responseId, typeof quotes === 'undefined').always(function() {
				if (pagination.currentResponseId == responseId) {
					loadingSpinner.hide();
					updateDetails($('#request' + responseId + ' .preview'));
					if (global.isAdmin) {
						quoteDetails.loadActivityFeed(responseId);
					}
				}
			});
		}
    }
	
	kixExistCondition1 = setInterval(bindEventToKixie, 2000);

    if (window.getDetailCallback) {
        getDetailCallback(obj);
    }

	refreshYonyxWidgetData(!document.getElementById("openYonyxSidePanel"));
}

function fetchRequestDetails(requestId) {
	var request;

	for (var i = 0; i < requests.length; i++) {
		if (requests[i].requestId == requestId) {
			request = requests[i];
			break;
		}
	}
	if (!request) {
		return $.Deferred().resolve();
	}

	var promises = [];
	var detailsUrl = pagination.clientType == 'buyer' // || pagination.clientType == 'uhl' TODO:: Remove UHL
		? 'getBuyRequestAdminDetails-json'
		: 'getRequestAdminDetails-json';
	var detailsPromise = $.get(detailsUrl, {requestId: requestId}).then(function(data) {
		if (!checkAjax(data)) {
			return;
		}

		var adminComments = data.requestAdminComments || [];
		var realtors = data.realtors || [];
		$.extend(request, data.request);
		request.requestAdminComments = adminComments.map(formatCallMessages);
		request.wonAgentName = data.wonAgentName;
		if (request.requestAdminComments && request.requestAdminComments.length > 0 ) {
			request.requestAdminComments.map(function(adminComment){ return adminComment.comment=adminComment.comment.replace(/\</g,"&lt;") });
		}
		if (adminComments.length > 0 && realtors.length > 0) {
			for (var i = 0; i < adminComments.length; i++) {
				var comment = adminComments[i];
				var realtorId = comment.logger && comment.logger.realtorId;
				if (!realtorId) {
					continue;
				}
				for (var j = 0; j < realtors.length; j++) {
					if (realtors[j].realtorId == realtorId) {
						comment.realtor = realtors[j];
						break;
					}
				}
			}
		}

		//if (updateNotationNew(request)) {
		    var requestElement = $('main section.mainList .content #request' + requestId);
            var notesSection = requestElement.find('.notesSection');
            notesSection.replaceWith(
                hb.templates.details.adminRequestNotes($.extend({}, request, {notes: request.requestAdminComments})));
		//}
		if (data.needRecruit && $('#request' + requestId + ' .name.h35 .need-recruiting').length === 0) {
		    $('#request' + requestId + ' .name.h35').append('<i style="vertical-align:bottom;color:#75c7b0;font-size:21px;margin: 0 0 3px 0;" class="fa fa-search-plus need-recruiting bubbletip" title="Need recruiting. Less than 3 green agents in the area"/>');
		}
	});

	promises.push(detailsPromise);

	// TODO:: Remove UHL
	// if (pagination.clientType == 'uhl') {
	// 	var homeLoanDeatilsPromise = $.get('getHomeLoanDetails-json', {requestId: requestId}).then(function(data) {
	// 		request.homeLoanRequest = data.homeLoanRequest;
	// 		request.homeLoanDetails = data.homeLoanDetails;
	// 	});
	//
	// 	promises.push(homeLoanDeatilsPromise);
	// }

	if (request.user) {
		var userRequestsUrl = pagination.clientType === 'seller' ? 'getRequestsByUserIdRequestId-json' : 'getRequestsByUserIdRequestIdBuy-json';

		var userRequestsPromise = $.get(userRequestsUrl, {
			requestId: request.requestId,
			userId: request.user.userId
		}).then(function(data) {
			if (!checkAjax(data)) {
				return;
			}

			request.activeRequests = data.crs;
			request.clientAgentEmails = request.user.email + data.agentEmail;
			request.spokeo = true;

			var requestElement = $('main section.mainList .content #request' + request.requestId);
            var cardboardFilter = $('#cardboard-filter').val();
            request.cta = cardboardFilter;
			switch (pagination.clientType) {
				case 'seller': {
					var sellerProfile = requestElement.find('.sellerProfile');
					request.requestLatestComments = data.requestLatestComments;
					if (request.requestLatestComments[0]) {
						request.requestLatestComments[0].comment = request.requestLatestComments[0].comment.replace(/\</g,"&lt;");
					}
					if (global.isAdmin) {
						sellerProfile.replaceWith(hb.templates.details.adminSellerProfile(request));
					} else {
						sellerProfile.replaceWith(hb.templates.details.sellerProfile(request));
					}
					if (data.alsoBuyingOutside) {
						request.alsoBuyingOutside = data.alsoBuyingOutside;
					}

					request.enableLegacyMatchingPage = global.enableLegacyMatchingPage;

					var CTAadminSellerRequest = requestElement.find('.CTA .adminMenu');
					var CTAadminStats = requestElement.find('.CTA .adminStats');
					CTAadminStats.remove();
					request.sellPct = data.sellPct;
					CTAadminSellerRequest.replaceWith(hb.templates.CTA.adminSellerRequest(request));
					break;
				}
				case 'buyer': {
					var buyerProfile = requestElement.find('.buyerProfile');
					request.requestLatestComments = data.requestLatestComments;
					if (request.requestLatestComments[0]) {
						request.requestLatestComments[0].comment = request.requestLatestComments[0].comment.replace(/\</g,"&lt;");
					}
					// request.uhlSubmissionDate = data.uhlSubmissionDate; TODO:: Remove UHL
                    request.lastConnectedCallDate = data.lastConnectedCallDate;
					if (global.isAdmin) {
						buyerProfile.replaceWith(hb.templates.details.adminBuyerProfile(request));
					} else {
						buyerProfile.replaceWith(hb.templates.details.buyerProfile(request));
					}
					if (request.user.organization) {
						try {
							request.user.organization = JSON.parse(request.user.organization);
						} catch (err) {
							request.user.organization = null;
						}
					}
					break;
				}
			}
		});

		promises.push(userRequestsPromise);
	}

	var activeQuotesPromise = $.get('submittedQuotes-json?sort=createdOn', {
		requestId:requestId,
		buyer: pagination.clientType === 'buyer' //|| pagination.clientType === 'uhl' TODO:: Remove UHL
	}).then(function(data) {
		if (!checkAjax(data)) {
			return;
		}

		var quotes = pagination.clientType === 'buyer'
		// || pagination.clientType === 'uhl' TODO:: Remove UHL
			? data.bquotes : data.quotes;
		request.quotes = quotes;

		var connectedComment = (request.requestAdminComments || []).filter(function(c) {
			if (c.comment && c.comment.includes('This MAY BE a duplicate request')) {
				request.duplicatedRequestMessage = c.comment;
			}
			return (c.type === "outbound_call"
				&& !['OUTBOUND_CALL_VM', 'OUTBOUND_CALL_WRONG','OUTBOUND_CALL_NA'].includes(c.subType));
		}).pop() || {};
		request.invitedRealtorsData = quotes;
		request.declinedQuotes = quotes ? quotes.filter(function(q) {
			return [1, 9].includes(q.status) && (!q.inviteApprove || q.inviteApprove == 1);
		}) : [];
		request.declineCount = request.declinedQuotes.length;
		request.activeQuotes = quotes ? quotes.filter(function(q) {
			return [0, 2, 3, 4, 12].includes(q.status);
		}) : [];
		request.notifiedCount = quotes ? quotes.filter(function(q) {
            return q.status != -1 && (!q.inviteApprove || q.inviteApprove == 1);
        }).length : 0;
		request.activeQuotesCount = request.activeQuotes.length;
		request.pendingNotifyQuotes = quotes ? quotes.filter(function(q) {
			return q.status === 11;
		}) : [];
		request.pendingNotifyCount = request.pendingNotifyQuotes.length;
		request.adminWhichHandledConnection = (connectedComment.logger || {}).name;
	});

	promises.push(activeQuotesPromise);

	var suggestedRealtorsPromise = $.get(pagination.clientType === 'seller' ? 'sellerSuggestedAgents-json' : 'buyerSuggestedAgents-json', {
		requestId: requestId,
		buyer: pagination.clientType === 'buyer', // || pagination.clientType === 'uhl' TODO:: Remove UHL
		fromEmail: true,
	}).then(function(data) {
		request.suggestedRealtorsData = data.suggestedRealtors;
	});

	promises.push(suggestedRealtorsPromise);

	return $.when.apply($, promises).then(function() {
		var $request = $('#request' + requestId);
		if (pagination.currentRequestId == requestId) {
			var templates = {
				seller: hb.templates.sellerRequest.adminDetails,
				buyer: hb.templates.buyerRequest.adminDetails
				// uhl: hb.templates.UHLRequest.adminDetails TODO:: Remove UHL
			};
			$request.find('.details').replaceWith(templates[pagination.clientType](request));
		}
	});
}

function formatCallMessages(c) {
	if (["outbound_call", "inbound_call"].includes(c.type)) {
		switch (c.subType) {
			case "OUTBOUND_CALL_VM":
				c.comment = c.comment.replace('Called', 'VoiceMail');
				break;
			case "OUTBOUND_CALL_WRONG":
				c.comment = c.comment.replace('Called', 'WrongNumber');
				break;
            case "OUTBOUND_CALL_NA":
                c.comment = c.comment.replace('Called', 'NoAnswer');
                break;
		}
	}
	if (c.type == 'sys_outbound_sms') {
		var metadata = getMetadataObject(c.metadata);
		c.metadata = metadata;
	}
	return c;
}

function fetchResponseDetails(responseId, isBuyer) {
	var quote = $.grep(isBuyer ? bquotes : quotes, function(index, quote) {
		return quote.responseId == responseId;
	})[0];
	if (!quote) {
		return $.Deferred().resolve();
	}

	return $.get('getRealtorPerformanceStats-json', {
		realtorId: quote.realtor.realtorId
	}).then(function(data) {
		if (!checkAjax(data)) {
			return;
		}
		quote.realtor = data.realtor;
		var detailsTemplate;
		if (pagination.clientType == 'buyer' /* || pagination.clientType === 'uhl' TODO:: Remove UHL */) {
			detailsTemplate = pagination.admin
				? hb.templates.buyerQuote.adminDetails
				: hb.templates.buyerQuote.details;
		} else {
			detailsTemplate = pagination.admin
				? hb.templates.sellerQuote.adminDetails
				: hb.templates.sellerQuote.details;
		}
		var $detailsContent = $(detailsTemplate(quote)).html();
		var $mainList = $('main section.mainList');
		$mainList.find('.content #request' + responseId + ' .details').html($detailsContent);
	});
}

function getServiceValue(service){
	switch (service) {
		case 'photography':
			return 'Professional Photography';
		case 'website':
			return 'Dedicated Website';
		case 'online':
			return 'Online Marketing (Zillow, Trulia)';
		case 'postcards':
			return 'Postcard Marketing';
		case 'tour':
			return 'Virtual Tour';
		default:
			return service;
	}
}

function returnServices(servicesObj) {
	if (servicesObj == "" || servicesObj == "{}" || servicesObj == null) {
		return "N/A";
	} else {
		servicesObj = $.parseJSON(servicesObj);
	}
	if (typeof servicesObj.version != 'undefined') {
		if (servicesObj.version == 2) {
			var str = "";
			for (j in servicesObj.fields) {
				str += getServiceValue(servicesObj.fields[j])+", ";
			}
			return str + "Competitive Market Analysis (CMA).";
		} else {
			return 'Error parsing data. Please contact our chat support.';
		}
	} else {
		return "This data is outdated and no longer supported.";
	}
}

function hackHandlebars(callback) {
	if (!window.hb || !window.hb.templates) {
        return;
	}
	Handlebars.partials = hb.templates;
	for (var i in Handlebars.partials) {
		for (var j in Handlebars.partials[i]) {
			Handlebars.partials[i+"."+j] = Handlebars.partials[i][j];
		}
	}
}

function filterQuoteByStatus(obj, category, initLoad) {
	if(!initLoad){
		$('.dropdown.sort.'+category+' .current').html($(obj).html());
	}
	if($(obj).attr('class') == "All"){
		$('.responseStatus-1').show();
	}else{
		if($('.responseStatus-0, .responseStatus-2, .responseStatus-3, .responseStatus-4').length){
			$('.responseStatus-1').hide();
		}else{
			$('.dropdown.sort.'+category+' .current').text('All');
		}
	}
	$('.count-props:visible').each(function(index) {
		$(this).text((index + 1) + '/' + $('.count-props:visible').length);
	});
}

function showPreviews(obj, category) {
	$('.dropdown.sort.'+category+' .current').html($(obj).html());
    var classAttr = $(obj).attr('class');
    if (!classAttr) {
        return;
    }
	if (classAttr.toUpperCase()=='EXPIRED OR DECLINED') {
        classAttr='EXPIREDDECLINED';
	}
    switch (classAttr.toUpperCase()) {
    	case 'ALL':
		case 'INVITED':
			$('section.mainList .preview').show();
			break;
		case 'ACTIVE':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status0, section.mainList .preview.status2, section.mainList .preview.status3').show();
			break;
		case 'OPEN':
		case 'PENDING':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status10').show();
			break;
		case 'NEED NOTIFY':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status11').show();
			break;
		case 'SUBMITTED':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status0').show();
			$('section.mainList .preview.status2').show();
			$('section.mainList .preview.status3').show();
			break;
		case 'DECLINED':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status1').show();
			break;
		case 'INTERVIEWING':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status2').show();
			break;
		case 'WON':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status3, section.mainList .preview.status4').show();
			break;
        case 'POSTPONED':
            $('section.mainList .preview').hide();
            $('section.mainList .preview.status12').show();
            break;
        case 'EXPIRED':
            $('section.mainList .preview').hide();
            $('section.mainList .preview.status9').show();
            break;
        case 'DELETED':
            $('section.mainList .preview').hide();
            $('section.mainList .preview.status-1').show();
            break;
        case 'EXPIREDDECLINED':
            $('section.mainList .preview').hide();
            $('section.mainList .preview.status1, section.mainList .preview.status9').show();
            break;
	}
	$('section.mainList .preview').is(":visible") ? $('section.mainList .noPreviews').hide() : $('section.mainList .noPreviews').show();
}

function showTabPreviews(obj, category) {
	$('.tab.filter').removeClass('current');
	$('.tab.filter.'+category).addClass('current');
    switch (category.toUpperCase()) {
    	case 'ALL':
		case 'INVITED':
			$('section.mainList .preview').show();
			break;
		case 'ACTIVE':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status0, section.mainList .preview.status2, section.mainList .preview.status3').show()
			break;
		case 'OPEN':
		case 'PENDING':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status10').show();
			break;
		case 'NOTIFY':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status11').show();
			break;
		case 'SUBMITTED':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status0').show();
			$('section.mainList .preview.status2').show();
			$('section.mainList .preview.status3').show();
			break;
		case 'DECLINED':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status1').show();
			break;
		case 'INTERVIEWING':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status2').show();
			break;
		case 'WON':
			$('section.mainList .preview').hide();
			$('section.mainList .preview.status3').show();
			break;
	}
	$('section.mainList .preview').is(":visible") ? $('section.mainList .noPreviews').hide() : $('section.mainList .noPreviews').show();
	getDetail($('.preview:visible').eq(0));
	$('.titleBar .tab.active .count').text($('section.mainList .content div.preview:visible').length);
}

function ajaxSort(obj, objType, category) { 
	var value = $(obj).html();
	if ($(obj).hasClass('sub')) {
		value = value.replace(/^\s*--\s*/, '');
	}
	$('.dropdown.sort.' + category + ' .current').html(value);
	
	pagination.getNewList(objType, 1);
}

function getPlaceAddressComponentByType(place, componentType) {
	var result = getPlaceAddressComponentByType2(place, componentType);
	return result ? result.long_name : null;
}

function getPlaceAddressComponentByType2(place, componentType) {
    if (!place || !place.address_components) {
        return null;
    }
    for (var i = 0; i < place.address_components.length; i++) {
		var types = place.address_components[i].types;
		if (types && types.indexOf(componentType) != -1) {
            return place.address_components[i];
        }
    }
    return null;
}

function getPlaceAddressComponentByTypeAndSize(place, componentType, long) {
	if (!place || !place.address_components) {
		return null;
	}
	for (var i = 0; i < place.address_components.length; i++) {
		for (var j = 0; j < place.address_components[i].types.length; ++j) {
			if (place.address_components[i].types[j] == componentType) {
				return long ? place.address_components[i].long_name : place.address_components[i].short_name;
			}
		}
	}
	return null;
}

function preventNewTokenCreation($elements, allowedTokens) {
    $elements.on('tokenfield:createtoken', function(event) {
        var exists = false;
        $.each(allowedTokens, function(index, token) {
            if (token === event.attrs.value) {
                exists = true;
            }
        });
        if (!exists) {
            event.preventDefault();
        }
    });
}

function preventDuplicateTokens($elements) {
    $elements.on('tokenfield:createtoken', function(event) {
        var existingTokens = $(this).tokenfield('getTokens');
		var newToken = event.attrs.value;
		if (newToken) {
			$.each(existingTokens, function(index, token) {
				if (newToken && newToken.toLowerCase() == token.value.toLowerCase()) {
					event.preventDefault();
				}
			});
		}
    });
}

function addStylesForToken($elements) {
    $("#not-my-service-area .token-label").css({
        "max-width": "100%"
    });
    $elements.on('tokenfield:createdtoken', function(event) {
        $("#not-my-service-area .token-label").css({
            "max-width": "100%"
        });
    });
}

function agentDeclineQuote(id, url, buy, address, cities, city, state, isAsAgent, realtorId, priceRangeMin, priceRangeMax, agentOffDate, agentReturnDate, propertyZip, propertyCity, excludedArea) {
	agentDeclineQuote2({
		id: id,
		url: url,
		buy: buy,
		address: address,
		cities: cities,
		city: city,
		state: state,
		isAsAgent: isAsAgent,
		realtorId: realtorId,
		priceRangeMin: priceRangeMin,
		priceRangeMax: priceRangeMax,
		agentOffDate: agentOffDate,
		agentReturnDate: agentReturnDate,
		propertyZip: propertyZip,
		propertyCity: propertyCity,
		excludedArea: excludedArea
	});
}

function agentDeclineQuote2(params) {
    var agentOffDates = params.agentOffDate.split('T')[0].split('-');
    var agentReturnDates = params.agentReturnDate.split('T')[0].split('-');

	var obj = {
		id: params.id,
		buy: params.buy,
		address: params.address,
		cities: params.cities,
		city: params.city,
		state: params.state,
        isAsAgent: params.isAsAgent,
        priceRangeMin: params.priceRangeMin,
        priceRangeMax: params.priceRangeMax,
        agentOffDate: params.agentOffDate.split('T')[0],
        agentReturnDate: params.agentReturnDate.split('T')[0],
        agentOffDateInput: agentOffDates[1] + '-' + agentOffDates[2] + '-'+ agentOffDates[0],
		agentReturnDateInput: agentReturnDates[1] + '-' + agentReturnDates[2] + '-'+ agentReturnDates[0],
		propertyCity: params.propertyCity,
		propertyZip: params.propertyZip,
		redirectToDashboard: params.redirectToDashboard
	};
	if (!!params.excludedArea) {
		obj.excludedArea = params.excludedArea;
	}
    obj.cities = obj.cities.split(/\s*,\s*/);

    var $customPopupDiv = "customPopupDiv";
    customPopupContentRounded(
    	$customPopupDiv,
    	hb.templates.CTA.agentDeclineQuote(obj),
        '349px',
		'auto',
		'9px',
		'Can you share why you are declining this request?',
		params.url
	);
    customPopupContentRoundedCss();
    $("#submit_btn").val("Decline Request");
	$("#submit_btn").click(function (e) {
		trackEvent('Quote', 'agentDeclineQuote', 'agentDeclineQuote').withGA();
		// UPC-120: validate dates before submitting formand assign current values to inputs
		if ($("[name='agentRejectReason']").val() && $("[name='agentRejectReason']").val() === "I am currently away") {
			$("#agentReturnDate").val($("#agentReturnDateInput").val());
			$("#agentOffDate").val($("#agentOffDateInput").val());
			if ($("#agentReturnDateInput").val() == '' || $("#agentOffDateInput").val() == '') {
				var errMsg = ("Please enter the Agents " + ($("#agentOffDateInput").val() == '' && $("#agentReturnDateInput").val() == '' ? 'Off and Return Dates' :
					($("#agentOffDateInput").val() == '' ? 'Off Date' : 'Return Date')));

				showSimpleTextModal({ text: errMsg, textAlign: 'center' });

				e.preventDefault();
			}
		}
	});
    $("#submit_btn").css({
		"font-size": "16px",
        "box-shadow": "0 4px 8px 0 rgba(255, 153, 72, 0.3), 0 0 4px 0 rgba(255, 153, 72, 0.1)",
    	"border-radius": "24px"
    });
    $(".btn-round").css({
        "height": "40px"
    });
    var $customPopupDiv = $("#customPopupDiv");
	var $popupContact = $('#popupContact');
    $customPopupDiv
		.css("overflow", "inherit")
		.height("auto").addClass('decline-proposal-modal');

    // $("[name='agentRejectReasonForm']").focus(function(e) {
    //     e.preventDefault();
    //     if ($('.reason-not-working-body').hasClass("reason-not-working-body-block")) {
    //         $('.reason-not-working-body').css("display", "none");
    //         $('.reason-not-working-body').removeClass("reason-not-working-body-block");
	// 	} else {
    //         $('.reason-not-working-body').css("display", "block");
    //         $('.reason-not-working-body').addClass("reason-not-working-body-block");
	// 	}
    //     $(".reason-block").focus();
    // });

    // $("[name='agentRejectReasonSpan']").click(function(e) {
    //     e.preventDefault();
    //     if ($('.reason-not-working-body').hasClass("reason-not-working-body-block")) {
    //         $('.reason-not-working-body').css("display", "none");
    //         $('.reason-not-working-body').removeClass("reason-not-working-body-block");
    //     } else {
    //         $('.reason-not-working-body').css("display", "block");
    //         $('.reason-not-working-body').addClass("reason-not-working-body-block");
    //     }
    //     $(".reason-block").focus();
    // });

    // $("[name='agentRejectReasonForm']").click(function(e) {
    //     e.preventDefault();
    //     $("[name='agentRejectReasonForm']").blur();
    // });

    // $(".reason-not-working-body li").hover(function() {
    //     $(".reason-not-working-body li").removeClass("reason-not-working-body-hover");
    //     $(this).addClass("reason-not-working-body-hover");
    // });
	$("[name='agentRejectReasonForm']").change(handleReasonChoice);

	$('.address-block > .btn').click(function(e) {
		e.preventDefault();
		$(this).hide();
		$('.address-block #address').attr('disabled', false);
	});

    $("[name='declineReason']").on('input', function() {
        var reason = $("[name='declineReason']").val();
    	if (reason.length > 2) {
            $("#submit_btn").removeClass("disabled");
            $("[name='agentRejectReason']").val(reason);
		} else {
            $("#submit_btn").addClass("disabled");
		}
	});
	
	$('[name="removeArea"]').change(function() {
		if ($(this).val() == 'true') {
			$('#excludedArea').tokenfield('createToken', { value: params.propertyCity, label: params.propertyCity });
		}
		$("#submit_btn").removeClass("disabled");
	});

    function handleReasonChoice() {
		var reasonControl = $(this).data('control');
		$(this).closest('form').find('>div').first().hide();
    	$('.give-me-reason').hide();
		$('.reject-reason-block').hide();
		$('#' + reasonControl).show();
		$popupContact.css('width', '525px');

		var reason;
		switch (reasonControl) {
			case 'not-my-service-area':
				reason = "Not my service area";
				break;
			case 'not-my-price-point':
				reason = "Not my price point";
				$("#submit_btn").removeClass("disabled");
				break;
			case 'not-work-with-buyers':
				reason = "I don\'t work with buyers";
				break;
			case 'currently-away':
				reason = "I am currently away";
				$("#submit_btn").removeClass("disabled");
				break;
			default:
				reason = $(this).val();
		}

        $("[name='agentRejectReason']").val(reason);
        $('.reason-not-working-body').removeClass("reason-not-working-body-block");

		if (reasonControl === 'not-my-price-point') {
			$customPopupDiv.find('input[name=priceRangeMin], input[name=priceRangeMax]').dollarFormatted();
		} 

		var firstTry = true;
		$('[name=declineReason]').closest('form').submit(function (event) {
			if (firstTry && reasonControl === 'not-my-service-area' && !!$('#excludedArea').val()) {
				firstTry = false;
				var $form = $(this);
				event.preventDefault();
				var excludeAreaData = {
					realtorId: params.realtorId,
					responseId: params.id,
					isBuyer: params.buy,
					excludedArea: $('#excludedArea').val()
				};
				//EXCLUDE AREA
				return $.post('addRealtorExcludedArea-json', excludeAreaData).then(function() {
					$form.submit();
				});
			}
		});
  
		centerPopup();
    }

	function updateServicedAreas(tokens){
		var servicedAreas = [];
		if (tokens != null){
			tokens.forEach(function(token) {
				servicedAreas.push(token.label);
			});
		} 
		$("#servicedArea").val(servicedAreas.join(','));
	}


    $.get('getAllowedAreas-json?realtorId=' + params.realtorId).then(function(areas) {
        var allowedAreas = eval('(' + areas.allowedAreas + ')');
        var $area = $('#area');
		var $excludedArea = $('#excludedArea');
        if (!allowedAreas) {
            $area.val("");
        } else {
			var currentCities = obj.cities.length > 7 ? obj.cities.slice(0, 7) : obj.cities.toString();
            $area.val(currentCities);
			$('#areaNum').text((currentCities || '').split(',').length || 0);
            $area.tokenfield({
                limit: 7,
                autocomplete: {
                    source: Object.keys(allowedAreas),
                    delay: 100,
                    appendTo: '#area-opinions',
                    open: function(event, ui) {
                        var existingTokens = $area.val().split(',');
                        if (existingTokens.length >= 7) {
                            $('#area-opinions ul').hide();
                        }
                    }
                },
                showAutocompleteOnFocus: true
            });

			$excludedArea.tokenfield({
				limit: global.maxExcludedCitiesNumber,
				autocomplete: {
					source: Object.keys(allowedAreas),
					delay: 100,
					appendTo: '#excludedArea-opinions',
					open: function(event, ui) {
						var existingTokens = $excludedArea.val().split(',');
						if (existingTokens.length >= global.maxExcludedCitiesNumber) {
							$('#excludedArea-opinions ul').hide();
						}
					}
				},
				showAutocompleteOnFocus: true
			});
        }
        preventDuplicateTokens($area);
		updateServicedAreas($area.tokenfield('getTokens'));
		$area.change(function() {
			$('#areaNum').text($(this).tokenfield('getTokens').length || 0);
			updateServicedAreas($area.tokenfield('getTokens'));
		});
        addStylesForToken($area);
        preventDuplicateTokens($excludedArea);
        addStylesForToken($excludedArea);
    });

    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({address: obj.address}, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            var autocomplete = new google.maps.places.Autocomplete(document.getElementById("address"), {
                bounds: results[0].geometry.bounds,
                types: ['geocode'],
                componentRestrictions: {country: 'us'}
            });

            google.maps.event.addListener(autocomplete, 'place_changed', function() {
                var place = autocomplete.getPlace();
                var zip = getPlaceAddressComponentByType(place, 'postal_code');
                $.get('getAllowedAreas-json?zip=' + zip).then(function(areas) {
                    var allowedAreas = eval('(' + areas.allowedAreas + ')');
                    var $area = $('#area');
					var $excludedArea = $('#excludedArea');
                    $area.tokenfield('destroy');
                    $excludedArea.tokenfield('destroy');
                    if (!allowedAreas) {
                        $area.val("");
                    } else {
                        var allowedAreasKeys = Object.keys(allowedAreas).sort();
                        var allowCities = allowedAreasKeys.filter(
                            function(e) {
                                return this.indexOf(e) >= 0;
                            },
                            obj.cities
                        );
                        $area.val(allowCities.length > 7 ? allowCities.slice(0, 7) : allowCities.toString());

                        $area.tokenfield({
                            limit: 7,
                            autocomplete: {
                                source: allowedAreasKeys,
                                delay: 100,
                                appendTo: '#area-opinions',
                                open: function(event, ui) {
                                    var existingTokens = $area.val().split(',');
                                    if (existingTokens.length >= 7) {
                                        $('#area-opinions ul').hide();
                                    }
                                }
                            },
                            showAutocompleteOnFocus: true
                        });

						$excludedArea.tokenfield({
							limit: 7,
							autocomplete: {
								source: Object.keys(allowedAreas),
								delay: 100,
								appendTo: '#excludedArea-opinions',
								open: function(event, ui) {
									var existingTokens = $excludedArea.val().split(',');
								}
							},
							showAutocompleteOnFocus: true
						});
                        preventDuplicateTokens($area);
                        addStylesForToken($area);
                        preventDuplicateTokens($excludedArea);
                        addStylesForToken($excludedArea);
                    }
                });

                for (var i in place.address_components) {
                    var comp = place.address_components[i];
                    if ($.inArray("postal_code", comp.types) !== -1) {
                        $('.agent-decline-proposal [name=zip]').val(comp.long_name);
                    }
                    if ($.inArray("locality", comp.types) !== -1) {
                        $('.agent-decline-proposal [name=city]').val(comp.long_name);
                    }
                    if ($.inArray("administrative_area_level_1", comp.types) !== -1) {
                        $('.agent-decline-proposal [name=state]').val(comp.short_name);
                    }
                }
            });
        }
    });
}

function confirmDelete(responseId, isBuyer) {
	customPopupContent("<h1 style='margin-top:0'>Delete Proposal</h1><div>Please, select a reason <font style='color: red'>*required?</font><br /><br>" +
		"<div style='font-size: 15px;' onclick='$(\"#comm_high\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"comm_high\" name=\"delete_reason\" value=\"Commission_too_high\" checked><label>Commission too high</label></div>" +
		"<div style='font-size: 15px;' onclick='$(\"#client_far\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"client_far\" name=\"delete_reason\" value=\"Too_far_from_client\"><label>Too far from client</label></div>" +
		"<div style='font-size: 15px;' onclick='$(\"#prefer_gender\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"prefer_gender\" name=\"delete_reason\" value=\"Prefer_gender\"><label>Prefer gender</label></div>" +
		"<div style='font-size: 15px;' onclick='$(\"#same_brokerage\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"same_brokerage\" name=\"delete_reason\" value=\"Same_brokerage_as_competing_agent\"><label>Same brokerage as competing agent</label></div>" +
		"<div style='font-size: 15px;' onclick='$(\"#lack_exp\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"lack_exp\" name=\"delete_reason\" value=\"Lack_of_experience_for_the_price_point\"><label>Lack of experience for the price point</label></div>" +
		"<div style='font-size: 15px;' onclick='$(\"#lang_preference\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"lang_preference\" name=\"delete_reason\" value=\"Language_preference\"><label>Language preference</label></div>" +
		"<div style='font-size: 15px;' onclick='$(\"#many_proposals\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"many_proposals\" name=\"delete_reason\" value=\"Not_competitive_Too_many_proposals\"><label>Not competitive(Too many proposals)</label></div>" +
		"<div style='font-size: 15px;' onclick='$(\"#other\").prop(\"checked\", true);'><input class='input radiobutton-delete' style='margin-right: 4px' type=\"radio\" id=\"other\" name=\"delete_reason\" value=\"other\"><label>Others</label><input class='deleted_reason_text' id='deleted_reason' type='text' name='deleted_reason' placeholder='please type a reason'></div></div>" +
		"<br /><a class='btn btn-warning' onclick=\"submitDeleteRequest("+responseId+", "+isBuyer+", $('input[name=delete_reason]:checked').val());\">Yes</a>", 'auto', 'auto');
}

function submitDeleteRequest(responseId, isBuyer, reason) {
    if (reason == "other") {
        reason = $("#deleted_reason").val();
    }
    disablePopup();
    var endPoint = isBuyer? "delete-buyer-quote" : "deleteQuote";
    $.post(endPoint, {
        quoteId: responseId,
        deletedReason: reason,
        isBuyer: isBuyer
    }).then(function() {
        if (pagination.clientType) {
            pagination.getNewList('quote', 1);
        } else {
            window.location.reload(true);
        }
    });
}

function submitUpcallLeadDialog(responseId, isBuyer) {
    customPopupContent('<h1 style="margin-top:0">Submit Upcall Lead</h1><form id="popupForm" action="addUpcallAgentLead-json" method="POST">' +
        '<select name="campaignId"></select>' +
        '<input type="hidden" name="responseId" value="' + responseId + '"/>' +
        '<input type="hidden" name="buyer" value="' + isBuyer + '"/>' +
        '<br/><br/><textarea name="notes" style="width:100%; height: 40px; resize: none" placeholder="Optional"></textarea><br/>' +
        '<input type="submit" value="Submit" class="mediumredbutton"></form>', '300px', 'auto');
    $.get('getUpcallCampaigns-json').then(function(data) {
        var campaignSelect = $('[name=campaignId]');
        $(data.campaigns).each(function(i, campaign) {
            campaignSelect.append($('<option/>').val(campaign.id).text(campaign.name));
        });
    });
    ajaxThis('addUpcallLead');
}

function confirmUnexpire(yesUrl, noUrl) {
	customPopupContent("<h1 style='margin-top:0'>Unexpire Proposal</h1>" +
	    "<div>Resend invitation notifications to the agent?<br /><br />" +
	        '<a href="' + yesUrl + '" class="btn btn-warning">Yes</a>&nbsp;&nbsp;' +
	        '<a href="' + noUrl + '" class="btn btn-danger">No</a>',
	        'auto', 'auto');
}

function confirmNotifySeller(quoteId, yearsOfExp) {
	if (yearsOfExp < 3) {
		var html = "Stop, this agent has < 3 years of experience, do you still want to notify?<br><br>"
			+ '<a href="javascript:void(0)" class="btn btn-warning" style="margin-right: 10px" onclick="notifySeller(' + quoteId + ')">Yes</a>'
			+ '<a href="javascript:void(0)" class="btn btn-danger" onclick="disablePopup()">No</a>';
		customPopupContent(html, 240, 'auto');
	} else {
		notifySeller(quoteId);
	}
}

function showConfirmationDialog(title, yesHandler, onClose) {
    var $modal = $('#bsConfirmationModal');
    if ($modal.length > 0) {
        $modal.remove();
    }
    $('body').append(hb.templates.bootstrapConfirmationDialog());
    $modal = $('#bsConfirmationModal');
    $modal.find('.modal-title').text(title);
    (typeof onClose === 'function') && $modal.on('hide.bs.modal', onClose);

    $modal.find('.btn-primary').click(function (event) {
        $(this).attr('disabled', 'disabled');
        if (typeof yesHandler === 'function') {
            var promise = yesHandler(event);
            if (promise && typeof promise.then === 'function') {
                promise.then(function () {
                    $modal.modal('hide');
                });
            } else {
                $modal.modal('hide');
            }
        } else {
            $modal.modal('hide');
        }
    });
    $modal.modal();
}

function notifySeller(quoteId) {
	var html = "<h1 style='margin-top:0'>Notify Seller</h1><div>Mark agent popular:&nbsp"
		+ "<input type='checkbox' name='popular' value='' onclick='markProposalPopular(this,"+quoteId+")'>"
		+ "<hr>"
		+ "Notify agent and customer via sms and email?<br /><br />"
		+ "<a href='adminNotifySellerProposal?quoteId=" + quoteId + "&sort=" + pagination.sort +"' class='btn btn-warning notify-yes-button'>Yes</a>"
		+ "&nbsp; &nbsp;"
		+ "<a href='adminNotifySellerProposal?noNotification=true&quoteId=" + quoteId + "&sort=" + pagination.sort +"' class='btn btn-danger notify-no-button'>No</a></div>";
	customPopupContent(html, 240, 'auto');
}

function markProposalPopular(target, quoteId) {
	$(target.parentNode).find('.notify-yes-button').attr('href','adminNotifySellerProposal?quoteId=' + quoteId + '&sort=' + pagination.sort + '&popular=' + !!target.checked);
	$(target.parentNode).find('.notify-no-button').attr('href','adminNotifySellerProposal?noNotification=true&quoteId=' + quoteId + '&sort=' + pagination.sort + '&popular=' + !!target.checked);
}

function introduceAgent(quoteId, buy) {
	var form = "This client gave consent for agents to contact them. Clicking \"Send\" will send this agent the client's number and email. <br/><br/>Send seller's contact info to this agent and notify client of proposal?<br /><br />" +
				"<input type='hidden' name='quoteId' value=" + quoteId + " />" +
				"<input type='checkbox' name='preferEmail' value='true'/> client prefers email<br><br>" +
                "<input type='checkbox' name='popular' value='true'/> Mark agent popular<br><br>" +
				"<input type='hidden' name='sort' value="+ pagination.sort +" />";
	var methodName = "adminNotifyAndIntroduce";
	if (buy == 'true') {
		methodName = methodName + "Buy";
	}
	customPopupForm('Send', methodName, 'Notify and Introduce', 'auto', 'auto', form);
}

function adminNotifyandIntroduce() {
	if(!$('input[name="notify-agent"]:checked') || $('input[name="notify-agent"]:checked').size() < 1) {
		customPopupContent("<h4> Please at least select One proposal to Notify and Introduce</h4>", 240, 'auto');
		return;
	}
	var form = "This client gave consent for agents to contact them. Clicking \"Send\" will send this agent the client's number and email. <br/><br/>Send seller's contact info to this agent and notify client of proposal?<br /><br />" +
				"<input type='checkbox' name='preferEmail' value='true'/> client prefers email<br><br>" +
				"<input type='hidden' name='sort' value="+ pagination.sort +" />";
	var actionName = 'adminNotifyAndIntroduce?';
	var selectedQuotes = '';
	$('input[name="notify-agent"]:checked').each(function() {
		selectedQuotes+= 'notifiedIntroducedQuoteIds='+ $(this).attr('value') + '&';
	});
	actionName += selectedQuotes;
	customPopupForm('Send', actionName, 'Notify and Introduce', 'auto', 'auto', form);
}

function adminNotifyWithNotification(notification) {
	if(!$('input[name="notify-agent"]:checked') || $('input[name="notify-agent"]:checked').size() < 1) {
		customPopupContent("<h4> Please at least select One proposal to Notify</h4>", 240, 'auto');
		return;
	}

	var selectedQuotes = "";
	$('input[name="notify-agent"]:checked').each(function() {
		selectedQuotes+= 'notifiedQuoteIds='+ $(this).attr('value') + '&';
	});

	selectedQuotes = notification? selectedQuotes : selectedQuotes +"noNotification=true";
	window.location.href = 'adminNotifySellerProposal?'+selectedQuotes;
}

function confirmNotifyBuyer(quoteId, yearsOfExp) {
	if (yearsOfExp < 3) {
		var html = "Stop, this agent has < 3 years of experience, do you still want to notify?<br><br>"
			+ '<a href="javascript:void(0)" class="btn btn-warning" style="margin-right: 10px" onclick="notifyBuyer(' + quoteId + ')">Yes</a>'
			+ '<a href="javascript:void(0)" class="btn btn-danger" onclick="disablePopup()">No</a>';
		customPopupContent(html, 240, 'auto');
	} else {
		notifyBuyer(quoteId);
	}
}

function notifyBuyer(quoteId) {
	var html = "<h1 style='margin-top:0'>Notify Buyer</h1>"
		+ "<div>Mark agent popular:&nbsp<input type='checkbox' name='popular' value='' onclick='markBuyProposalPopular(this,"+quoteId+")'><hr>Notify agent and customer via sms and email?"
		+ "<br /><br />"
		+ "<a href='adminNotifyBuyerProposal?quoteId=" + quoteId + "&sort=" + pagination.sort +"' class='btn btn-warning notify-yes-button'>Yes</a>"
		+ "&nbsp; &nbsp;"
		+ "<a href='adminNotifyBuyerProposal?noNotification=true&quoteId=" + quoteId + "&sort=" + pagination.sort +"' class='btn btn-danger notify-no-button'>No</a></div>"
	customPopupContent(html, 240, 'auto');
}

function markBuyProposalPopular(target, quoteId) {
	$(target.parentNode).find('.notify-yes-button').attr('href','adminNotifyBuyerProposal?quoteId=' + quoteId + '&sort=' + pagination.sort + '&popular=' + !!target.checked);
	$(target.parentNode).find('.notify-no-button').attr('href','adminNotifyBuyerProposal?noNotification=true&quoteId=' + quoteId + '&sort=' + pagination.sort + '&popular=' + !!target.checked);
}

function directMatch(quoteId) {
	customPopupForm('Quick Match', 'adminNotifySellerProposal', 'Quick Match', 440, 'auto', hb.templates.adminForms.directMatch());
	$('#popupContact h1').css('margin','0 0 .5em 15px');
	$('#popupSubmit').attr('class','btn btn-default');
	$('#popupSubmit').css('margin-right','15px');
	$('#popupForm [name=quoteId]').val(quoteId);
	$('#popupForm').attr('target','_blank');

	$("#popupForm").submit(function(e) {
		var self = this;
		e.preventDefault();

        var fields = [
            {sellerPct: 'input[name="quote.sellerPct"]'},
            {buyerPct: 'input[name="quote.buyerPct"]'},
            {tagLine: 'input[name="tagLine"]'}
        ]
        var isValid = true;

        fields.forEach(function(field) {
            var key = Object.keys(field)[0];
            var inputField = $(field[key]);
            var value = inputField.val();
            var errorMessageElement = inputField.next();
            var isEmpty = value.trim() === '';
            errorMessageElement.toggle(isEmpty);

            if (isEmpty) {
                isValid = false;
            }
        });

        if (!isValid) {
            return false;
        }

		postData = $('.freeServices input').fieldSerialize();
		var obj = new Object();
		obj.version = '2';
		var fields = new Array();
		if (postData != '') {
			services = postData.split("&");
			for (i in services) {
				serviceOffered = services[i].split("=");
				if (serviceOffered[1] == '1') {
					fields.push(serviceOffered[0]);
				}
			}
		}
		obj.fields = fields;
		$('#serviceOffering').val(JSON.stringify(obj));
		self.submit();
	});
}

function addVoice(id,url) {
	if (/MSIE/.test(navigator.userAgent)) {
		$('.quoteId'+id+' .apVoiceUrl').html('<embed id="embeddedAudio" style="display:block;padding:1em 0 .5em;width:100%" type="audio/x-mpeg" src="'+url+'?sessid='+Math.random()+'" autoplay="false" autostart="false" width="300" height="15">');
	} else if (ipad = /ipad/.test(navigator.platform.toLowerCase())) {
		$('.quoteId'+id+' .apVoiceUrl').html('<audio id="embeddedAudio" style="display:block;padding:0;width:100%;height:70px" controls preload="auto" autobuffer><source src="'+url+'?sessid='+Math.random()+'" type="audio/mpeg"><embed src="'+url+'?sessid='+Math.random()+'"></audio>');
	} else if ((ffVersion != undefined && ffVersion < 21) || Opera) {
		$('.quoteId'+id+' .apVoiceUrl').html('<audio id="embeddedAudio" style="display:block;padding:0;width:100%" controls preload="auto" autobuffer><source src="'+url.substr(0,url.length-4)+'?sessid='+Math.random()+'" type="audio/wav"><embed src="'+url.substr(0,url.length-4)+'?sessid='+Math.random()+'"></audio>');
	} else if (!!navigator.userAgent.match(/Trident.*rv[ :]*11\./)) {
		$('.quoteId'+id+' .apVoiceUrl').html('<audio id="embeddedAudio" style="display:block;padding:0;width:100%;height:30px" controls preload="auto" autobuffer><source src="'+url+'?sessid='+Math.random()+'" type="audio/mpeg"><embed src="'+url+'?sessid='+Math.random()+'"></audio>');
	} else if (ffVersion != undefined ) {
		$('.quoteId'+id+' .apVoiceUrl').html('<audio id="embeddedAudio" style="display:block;padding:0;width:100%" controls preload="auto" autobuffer><source src="'+url+'?sessid='+Math.random()+'" type="audio/mpeg"></audio>');
	} else {
		$('.quoteId'+id+' .apVoiceUrl').html('<audio id="embeddedAudio" style="display:block;padding:0;width:100%" controls preload="auto" autobuffer><source src="'+url+'?sessid='+Math.random()+'" type="audio/mpeg"><embed src="'+url+'?sessid='+Math.random()+'"></audio>');
	}
}

function formatPrice(num) {
	return '$' + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g,  ',');
}

function formatCommission(comm) {
	if (comm != null && !isNaN(comm)) {
		return Number(comm).toFixed(2) + '%';
    }
    return comm;
}

function formatFileSize(size) {
	var doFormat = function(value, suffix) {
		return (value < 100 ? value.toFixed(1).replace(/0+$/, '') : Math.round(value)) + ' ' + suffix;
	};
	if (size < 1024) {
		return size + ' bytes';
	}
	size /= 1024;
	if (size < 1024) {
		return doFormat(size, 'KB');
	}
	size /= 1024;
	if (size < 1024) {
		return doFormat(size, 'MB');
	}
	return doFormat(size, 'GB');
}

function isNumeric(str) {
	return returnNumbersOnly(str) == str;
}

function isValidEmailAddress(emailAddress) {
    var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    return pattern.test(emailAddress);
}

var US_PHONE_AREA_CODES = [
	205, 251, 256, 334, 659, 938, 907, 236, 250, 778, 480, 520, 602, 623, 928, 327, 479, 501,
	870, 209, 213, 279, 310, 323, 341, 408, 415, 424, 442, 510, 530, 559, 562, 619, 626, 628,
	650, 657, 661, 669, 707, 714, 747, 760, 805, 818, 820, 831, 840, 858, 909, 916, 925, 949,
	951, 303, 719, 720, 970, 203, 475, 860, 959, 302, 202, 771, 239, 305, 321, 352, 386, 407,
	448, 561, 656, 689, 727, 754, 772, 786, 813, 850, 863, 904, 941, 954, 229, 404, 470, 478,
	678, 706, 762, 770, 912, 943, 808, 208, 986, 217, 224, 309, 312, 331, 447, 464, 618, 630,
	708, 730, 773, 779, 815, 847, 872, 219, 260, 317, 463, 574, 765, 812, 930, 319, 515, 563,
	641, 712, 316, 620, 785, 913, 270, 364, 502, 606, 859, 225, 318, 337, 504, 985, 207, 227,
	240, 301, 410, 443, 667, 339, 351, 413, 508, 617, 774, 781, 857, 978, 231, 248, 269, 313,
	517, 586, 616, 679, 734, 810, 906, 947, 989, 218, 320, 507, 612, 651, 763, 952, 228, 601,
	662, 769, 314, 417, 557, 573, 636, 660, 816, 975, 406, 308, 402, 531, 702, 725, 775, 603,
	201, 551, 609, 640, 732, 848, 856, 862, 908, 973, 505, 575, 212, 315, 332, 347, 516, 518,
	585, 607, 631, 646, 680, 716, 718, 838, 845, 914, 917, 929, 934, 252, 336, 704, 743, 828,
	910, 919, 980, 984, 701, 216, 220, 234, 283, 326, 330, 380, 419, 440, 513, 567, 614, 740,
	937, 405, 539, 572, 580, 918, 458, 503, 541, 971, 215, 223, 267, 272, 412, 445, 484, 570,
	582, 610, 717, 724, 814, 878, 401, 803, 839, 843, 854, 864, 605, 423, 615, 629, 731, 865,
	901, 931, 210, 214, 254, 281, 325, 346, 361, 409, 430, 432, 469, 512, 682, 713, 726, 737,
	806, 817, 830, 832, 903, 915, 936, 940, 945, 956, 972, 979, 385, 435, 801, 802, 276, 434,
	540, 571, 703, 757, 804, 826, 948, 206, 253, 360, 425, 509, 564, 304, 681, 262, 274, 414,
	534, 608, 715, 920, 307
];

function isValidUSPhone(value) {
	var phone = returnNumbersOnly(value.toString());
	if (phone.length != 10) {
		return false;
	}
	var areaCode = phone.substring(0, 3);
	return US_PHONE_AREA_CODES.includes(+areaCode);
}

function isValidAddress(address) {
	var pattern = /^\d+[\s,]+[\w'.-]+[\s,\w'.-]+[,]+[\w'.\-\s]+[,].+/i;
	return pattern.test(address);
}

function isZillowUrl(zillowUrl) {
	var pattern = /https?:\/\/www\.zillow\.com\/profile\/([^/]*)\/?.*/i;
	return pattern.test(zillowUrl);
}

function isYelpUrl(yelpUrl) {
	var pattern = /https?:\/\/(www\.)?yelp\.com.*\/biz\/.+/;
	return pattern.test(yelpUrl);
}

function isRealtorComUrl(url) {
	return /https?:\/\/www\.realtor\.com\/realestateagents\/[^/]+/i.test(url);
}

function sortFormat(val, type) {
    switch (type) {
        case "date":
            return returnPrettyDate(val);
        case "timestamp":
            return returnPrettyDate(new Date(val));
        case "price":
            return formatPrice(val);
        case "percent":
            return val + "%";
		case "boolean":
			return val ? "Yes" : "No";
        default:
            return val;
	}
}

function addSort(col, obj) {
    var formattedName = '';
    var valueType = '';
	switch (col) {
		case "lastUpdated":
			formattedName = "Updated";
			valueType = "date";
			break;
		case "createdOn":
			formattedName = "Created";
			valueType = "date";
			break;
		case "createdOnTimestamp":
			formattedName = "Created";
			valueType = "timestamp";
			break;
		case "zestimate":
			formattedName = "Estimate";
			valueType = "price";
			break;
		case "lowRange":
			formattedName = "Low Range";
			valueType = "price";
			break;
		case "bidCount":
			formattedName = "Proposals";
			valueType = "";
			break;
		case "userOpenEmail":
			formattedName = "Opened Email";
			valueType = "date";
			break;
		case "awardedDate":
			formattedName = "Awarded Date";
			valueType = "date";
			break;
		case "matchDate":
			formattedName = "Match Date";
            valueType = "date";
		    break;
		case "signedDate":
			formattedName = "Signed Date";
			valueType = "date";
			break;
		case "listDate":
			formattedName = "List Date";
			valueType = "date";
			break;
		case "pendingDate":
			formattedName = "Pending Date";
			valueType = "date";
			break;
		case "soldDate":
			formattedName = "Sold Date";
			valueType = "date";
			break;
		case "sellerPct":
			formattedName = "Seller Percent";
			valueType = "percent";
			break;
		case "rebatePercent":
			formattedName = "Rebate Percent";
			valueType = "percent";
			break;
		case "status":
			formattedName = "Status";
			valueType = "";
			break;
		case "nextContactDate":
			formattedName = "Next Contact";
			valueType = "date";
			break;
		case "connectedTime":
			formattedName = "Connected Time";
			valueType = "date";
			break;
		case "lastVisit":
			formattedName = "Last Visit";
			valueType = "date";
			break;
		case "amLastUpdated":
			formattedName = "UA Last Updated";
			valueType = "date";
			break;
        case "loLastUpdated":
            formattedName = "LO Last Updated";
            valueType = "date";
            break;
		case "pendingDate":
			formattedName = "In Contract Date";
			valueType = "date";
			break;
		case "alsoBuying":
			formattedName = "Also Buying";
			valueType = "";
			break;
		case "rejectDate":
			formattedName = "Reject Date";
			valueType = "date";
			break;
		case "timeZone":
			formattedName = "Time Zone";
			valueType = "";
			break;
		case "score":
			formattedName = "Score";
			valueType = "";
			break;
		case "readyBy":
			formattedName = "Seller Stage";
			valueType = "";
			break;
        case "firstScheduledInterviewDate":
            formattedName = "Scheduled date";
            valueType = "date";
			break;
        case "expectedListDate":
            formattedName = "Expected List date";
            valueType = "date";
            break;
        case "expectedBuyingDate":
            formattedName = "Expected Buying date";
            valueType = "date";
            break;
        case "firstInterviewDate":
            formattedName = "Interview Date";
            valueType = "date";
			break;
		case "interviewDate":
            formattedName = "Interview Date";
            valueType = "date";
			break;
		case "confirmInterviewDate":
			formattedName = "Confirmed Interview";
			valueType = "date";
			break;
        case "scheduledInterviewDate":
            formattedName = "Scheduled Interview";
            valueType = "date";
            break;
        case "state":
            formattedName = "State";
            valueType = "";
            break;
		// 	TODO:: Remove UHL
        // case "uhlSubmissionDate":
        //     formattedName = "UHL Submission Date";
        //     valueType = "date";
        //     break;
        case "lastConnectedCallDate":
            formattedName = "UA Last Connected Call";
            valueType = "date";
            break;
        case "haventCalled":
			col = "createdOn";
            formattedName = "Created";
            valueType = "date";
            break;
    }
    if (typeof obj[col] != "undefined" || valueType == "boolean") {
        var formattedValue = sortFormat(obj[col], valueType);
        return formattedName + ": " + formattedValue;
    } else {
        return formattedName + ": N/A";
    }
}

// Function is called in list quotes by request and by listRequests: admin argument is being set as string but being evaluated against undefined. Because of this, it always has to be the last arg.
function reBuildRequest(request, newClientType, summary, admin) {
	if (typeof request == 'undefined') {
		return;
	}

	request.isManager = G.isManager;

	if (typeof admin != 'undefined') {
		if (admin != 'agent') {//todo need to fix this so admin arg is userType
			//allow admins to always see contact info and show spokeo/google links
			request.showContact = true;
			request.spokeo = true;
			request.google = true;

			//fix single quote for wonagent name
			if (typeof request.wonAgent != "undefined") {
				request.wonAgent = request.wonAgent.replace("'",'&apos;');
			}

			// Adding properties to request for google calendar
			var getUrl = window.location;
			var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
			request.timeNowCalendar = (new Date()).toISOString().replace(/-|:|\.\d\d\d/g,"");
			request.baseUrl = baseUrl;

			//format connectedTime date
			request = formatDateField(request,'connectedTime');

			//create need notify count
			if (typeof request.notifiedCount != 'undefined' && typeof request.declineCount != 'undefined' && typeof request.bidCount != 'undefined'){
				//request.needNotifyCount = request.notifiedCount - (request.declineCount + request.bidCount);

				//get pending notify count from database
				if (request.status == 11) {
					request.needNotifyCount = request.pendingNotifyCount;
				}
			}

			//add sort info
			var sortCategory;
			if (typeof pagination.getSortCategory == 'function') {
				sortCategory = pagination.getSortCategory(request);
			}
			if (sortCategory != null) {
				request.sortCategory = sortCategory;
			} else if (typeof pagination.sort != "undefined") {
				request.sortCategory = addSort(pagination.sort, request);
			}
		}
	} else {
		//hide connectedTime for non admins
		request.connectedTime = '';
		//hide deviceType for non admins
		request.deviceType = '';
		//hide competingAgents for non admins
		request.competingAgents = '';
		//hide talkNow for non admins
		request.talkNow = '';
		//hide IP for non admins
		request.ip = '';
	}
	// before this date, use old notes handlebar
	var releaseDate = new Date(2016, 5, 2, 0, 0, 0, 0);
	var createdOn = new Date(request.createdOn);
	//if (createdOn.getTime() > releaseDate.getTime()) {
		request.newNote = true;
	//}

	// format user phone and lastlogin date
	if (typeof request.user != 'undefined' && request.user != null) {
		request.user = formatDateField(request.user, 'lastLogin');
	}

	// format assignedAdmin phone
	if (typeof request.assignedAdmin != 'undefined' && request.assignedAdmin != null) {
		request.assignedAdmin = formatPhoneField(request.assignedAdmin, 'phone');
	}

	// format readyBy to show only if 60 days or less
	// if (request.readyBy != "60 Days" && request.readyBy != "30 Days" && request.readyBy != "Now" && request.readyBy != "Soon"){
	// 		request.readyBy = '';
	// }

	// format date
	request = formatDateField(request,'displayDate');
    if (request.agentPreference && typeof request.agentPreference == 'string') {
		request.agentPreference = request.agentPreference.trim().split(/\s*,\s*/);
	}

    // append buyer stuff
    if (newClientType == 'buyer'/* || newClientType == 'uhl' TODO:: Remove UHL */) {
        if (request.financing == "pre-approved") request.preapproved = true;
        if (request.financing == "CASH") request.cashBuyer = true;
        if (request.buyerStage == 0) {
            request.buyerStageStr = "Just Started";
        } else if (request.buyerStage == 2) {
            request.buyerStageStr = "Ready to Bid";
        }
	}

	if (summary) {
		if (typeof admin != 'undefined') {
			if (newClientType == 'seller') {
				$('main .summary').html(hb.templates.sellerRequest.adminSummary(request));
			} else if (newClientType == 'buyer') {
				if (admin == 'agent') {
					$('main .summary').html(hb.templates.buyerRequest.agentSummary(request));
				} else {
					$('main .summary').html(hb.templates.buyerRequest.adminSummary(request));
				}
			}
		} else {
			if (summary == 'multi') {
				if (newClientType == 'seller') {
					$('main .summary').append(hb.templates.sellerRequest.multi(request));
				} else if (newClientType == 'buyer') {
					$('main .summary').append(hb.templates.buyerRequest.multi(request));
				}
			} else {
				if (newClientType == 'seller') {
					$('main .summary').html(hb.templates.sellerRequest.summary(request));
				} else if (newClientType == 'buyer') {
					$('main .summary').html(hb.templates.buyerRequest.summary(request));
				}
			}
		}
	} else {
		if (typeof admin != 'undefined') {
			request.assignedAdminFirstName = 'Admin';
			if (typeof request != 'undefined' && typeof request.assignedAdmin != 'undefined' && typeof request.assignedAdmin.name != 'undefined') {
				request.assignedAdmin.name.split(" ")[0];
			}
			request.userJustFirstName = 'User';
			if (typeof request != 'undefined' && typeof request.user != 'undefined' && typeof request.user.name != 'undefined'){
				request.userJustFirstName = request.user.name.split(" ")[0];
			}

			if (newClientType == 'buyer' || newClientType == 'seller') {
				request.adminCommentBuyer = newClientType == 'buyer';
				request.isAdmin = true;
				request.enableLegacyMatchingPage = global.enableLegacyMatchingPage;
				request.currentDate = new Date().toLocaleDateString();
				request.crtUsersJSON = JSON.stringify(crtUsers);
				var cardboardFilter = $('#cardboard-filter').val();
				request.cta = cardboardFilter;
				$('main section.mainList > .content').append(
					newClientType == 'buyer' ? ( hb.templates.adminBuyerRequest(request))  : hb.templates.adminSellerRequest(request)
				);
			}
		}
	}

	return request;
}

function reBuildRequests(requests, newClientType, admin) {
	var $mainList = $('main section.mainList');
	if (!requests || requests.length == 0)  {
		$mainList.find('.noPreviews').show();
		return;
	}
	$mainList.find('.content').empty();
	$.each(requests, function() {
		reBuildRequest(this, newClientType, false, admin, false);
	});
	$mainList.add($('main section.mainDetails'))
		.toggleClass('seller buyer', false)
		// .toggleClass('seller buyer uhl', false) TODO:: Remove UHL
		.toggleClass(newClientType, true);
}

function reBuildQuote(quote, newClientType, admin) {
    quote.requestId = quote.request.requestId;

	//parse realtor portion of quote
	quote.realtor = reBuildRealtor(quote.realtor, admin);

	//format user phone, is this needed?
	if (typeof quote.user != 'undefined' && quote.user != null) {
		quote.user = formatPhoneField(quote.user, 'phone');
	}

	formatDateField(quote,'viewed_on');
	formatDateField(quote,'lastUpdated');

	if (typeof admin != 'undefined') {
		//allow admins to always see contact info
		quote.request.showContact = true;

		//always show spokeo info for admins
		quote.request.spokeo = true;

		//format request user phone
		if (typeof quote.request.user != 'undefined' && quote.request.user != null) {
			quote.request.user = formatPhoneField(quote.request.user,'phone');
		}

		//add sort info
		if (typeof pagination.sort != "undefined") {
			quote.sortCategory = addSort(pagination.sort, quote);
        }
	} else {
		//hide unneeded info for sellers and buyers
		quote.passcodeStr = '';
		quote.realtor.user.lastLogin = '';
	}

	if (newClientType == 'seller') {
		//set proposal page for mobile
		quote.proposalPage = proposalPage;

		//manually put in voice proposal number
		quote.voicePhoneNumbers = '4152758310';
		quote.voicePhone = '(415) 275-8310';

		//parse services
		if (typeof quote.serviceOffering != 'undefined' && quote.serviceOffering != null) {
			quote.serviceOffering = returnServices(quote.serviceOffering);
		} else {
			quote.serviceOffering = 'N/A';
		}

		//also show seller for admins and hide view proposal button
		quote.showViewProposal = true;
		if (typeof admin != 'undefined') {
			quote.showSeller = true;
		} else {
			if (quote.status != 0 && quote.status != 2 && quote.status != 3) {
				quote.showViewProposal = false;
			}
		}

		//append data
		if (typeof admin != 'undefined') {
			quote.isAdmin = true;
			$('main section.mainList .content').append(hb.templates.adminSellerQuote(quote));
		} else {
			$('main section.mainList .content').append(hb.templates.sellerQuote(quote));
		}
	} else {
		//manually put in voice proposal number
		quote.voicePhoneNumbers = '6608334787';
		quote.voicePhone = '(660) 833-4787';

		//parse rebate amounts
		if (quote.rebatePercent == 0) {
			quote.rebateAmt = quote.rebateAmountStr;
		} else {
			quote.rebateAmt = quote.rebatePercent+"%";
		}
		quote.agentAmt = quote.estimatedAgentShare;
		quote.upnestAmt = quote.defaultRebate;

		//also show buyer for admins
		if (typeof admin != 'undefined') {
			quote.showBuyer = true;
		}  else {
			//show friendlier rebate msg if buyer
			quote.upnestAmt = 150;
		}
		quote.adminCommentBuyer = true;

		//append data
		if (typeof admin != 'undefined') {
			quote.isAdmin = true;
			return hb.templates.adminBuyerQuote(quote);
		} else {
			return hb.templates.buyerQuote(quote);
		}
	}
}

function reBuildQuotes(quotes, newClientType, admin) {
	pagination.admin = admin;
	pagination.clientType = newClientType;

	if (typeof quotes == 'undefined' || !quotes || quotes.length == 0) {
		$('section.mainList .noPreviews').show();
		return;
	}

	//remove samples if quotes is larger than 1 for AMs and buyer/seller NOT agents, max@upnest.com on production, howard@upnest.com on beta, simonru@gmail.com for buy, simonru1@gmail.com for beta buy
	if (quotes.length > 1)  {
		for (i in quotes) {
			deleteQuote = false;
			if (typeof quotes[i].realtor.user != 'undefined' && quotes[i].realtor.user != null) {
				if (typeof quotes[i].realtor.user.email != 'undefined') {
					if (quotes[i].realtor.user.email == global.sampleRealtorEmail || quotes[i].realtor.user.email == 'howard@upnest.com' || quotes[i].realtor.user.email == 'simonru@gmail.com' || quotes[i].realtor.user.email == 'simonru1@gmail.com') {
						deleteQuote = true;
					}
				}
			}
			if (typeof quotes[i].request.user != 'undefined' && quotes[i].request.user != null) {
				if (typeof quotes[i].request.user.email != 'undefined') {
					if (quotes[i].request.user.email == global.sampleRealtorEmail || quotes[i].request.user.email == 'howard@upnest.com' || quotes[i].request.user.email == 'simonru@gmail.com' || quotes[i].request.user.email == 'simonru1@gmail.com') {
						deleteQuote = true;
					}
				}
			}
			if (deleteQuote) delete quotes[i];
		}
	}

    $('main section.mainList .content').empty();

	//loop through array and manipulate data
	for (i in quotes) {
		var html = reBuildQuote(quotes[i], newClientType, admin);
		$('main section.mainList .content').append(html);
	}
	if (newClientType == 'seller' && $('.quote.needNotify').attr('title')) {
		$('main section.notify').html(hb.templates.CTA.adminNotify(quotes[0].request));
	} else {
		$('main section.notify').hide();
	}
}

function initCollapsibleComments() {
    $('.admin-comment-list-item:visible:not(.collapsed):not(.expanded)').each(function() {
        var item = $(this);
        var container = item.find('.li-container').get(0);
        item.addClass('collapsed');
        if (container.offsetHeight < container.scrollHeight) {
            $(this).find('.show-more-less').show().click(function() {
                item.toggleClass('collapsed expanded');
            });
        } else {
            item.removeClass('collapsed');
        }
    });
}

function reBuildRealtor(realtor, admin) {
	if (typeof realtor != 'undefined') {
		if (realtor != null) {
			if (typeof admin != 'undefined') {
				realtor.license = '';
				realtor.specialty = '';
				realtor.grossSales = realtor.grossSales ? formatPrice(realtor.grossSales) : '';
			} else {
				realtor.soldAt = realtor.areas;
			}
			realtor = formatPhoneField(realtor,'bizPhone');
			if (typeof realtor.user != 'undefined' && realtor.user != null) {
				realtor.user = formatDateField(realtor.user,'lastLogin');
			}
			return realtor;
		}
	}
}

function hideLastName(nameStr) {
	var arr = nameStr.split(" ");
	var arrayLength = arr.length;
	newNameStr = '';
	if (arr.length > 1) {
		for (var i = 0; i < arrayLength; i++) {
 			if (i == (arrayLength - 1)) {
				newNameStr = newNameStr + arr[i].substr(0,1);
			} else {
				newNameStr = newNameStr + arr[i] + " ";
			}
		}
		return newNameStr;
	} else {
		return nameStr;
	}
}

function hideAddress(addr) {
	var arr = addr.split(" ");
	var arrayLength = arr.length;
	newAddr = '';
	if (arr.length > 1) {
		for (var i = 0; i < arrayLength; i++) {
 			if (i == 0) {
				newAddr = '###';
			} else {
				newAddr = newAddr + " " + arr[i];
			}
		}
		return newAddr;
	} else {
		return newAddr;
	}
}

function hideSortDropdown() {
	//a bit hacky but it works
	$('.titleBar .sort .dropdown-menu').css('height','0');
	$('.titleBar .sort .dropdown-menu').css('overflow','hidden');
	setTimeout(function() {
		$('.titleBar .sort .dropdown-menu').css('height','auto');
		$('.titleBar .sort .dropdown-menu').css('overflow','auto');
	},100);
}

var pagination = {};

pagination.getNewList = function(objType, where, callback) {
	//hide sorting dropdown
	hideSortDropdown();

	//set new data
	newStart = this.calculateStart(where);
	newUrl = this.buildNewListUrl(objType,newStart);
	newClientType = this.clientType;
    var requestId = this.requestId;
	var $loadingSpinner = $('section.mainList .loadingSpinner').show();

	//go to top
	mainListTop();

	$.get(newUrl, function(data) {		
        window.vmDropMessages = data.vmDropMessages;
        if (callback) {
            callback(data);
        }

        $('main section.mainList .content, .details.desktop').html('');
        $loadingSpinner.hide();

        if (!checkAjax(data)) {
            return;
        }

        $('main section.mainList').html(mainListDefault);

        if (objType == "request") {
            dataBreq = (newClientType == 'buyer') ? data.requests : undefined;
            requests = data.requests;
			pagination.requests = requests;
            reBuildRequests(requests, newClientType, 'admin');
        } else if (objType == 'quote') {
            //buyer-quote-list-json for some reason returns bquotes as oppposed to quotes
            buyHack = newClientType == 'buyer' ? 'b' : '';
            for (i in data[buyHack + 'quotes']) {
                if (data[buyHack + 'quotes'][i].statusStr == "Submitted") {
                    data[buyHack + 'quotes'][i].forceMatch = true;
                }
            }
            reBuildQuotes(data[buyHack + 'quotes'], newClientType, 'admin');
            if (requestId && data[buyHack + 'quotes']) {
                showPreviews($('.sort.Filter .dropdown-menu .Active'), 'Filter');
                getDetail($('.preview:visible').eq(0));
            }
        }

        //set pagination data
        pagination.start = newStart;
        pagination.setCurrentPage(where);
        if (data.requests) {
            pagination.showHidePrev(data.requests.length);
        }
        if (data.quotes) {
            pagination.showHidePrev(data.quotes.length);
        }
        if (data.bquotes) {
            pagination.showHidePrev(data.bquotes.length);
        }

        //show correct filter
        $('section.titleBar .dropdown.seller').hide();
		$('section.titleBar .dropdown.buyer').hide();

        // $('section.titleBar .dropdown.uhl').hide(); TODO:: Remove UHL
		$('section.titleBar .dropdown.'+newClientType).show();

		//select first result in preview list if in desktop view
		if ($('.details.desktop').is(':visible')) {
			getDetail($('.preview:visible').eq(0));
		}

		//init admin menu if it's a request and user is in desktop view
		if (objType == "request") {
			if ($('.details.desktop').is(':visible')) {
				initAdminMenuV2('main.container .details.desktop');
			}
		}

		//add count to correct tab
		$('.titleBar .tab .count').text("-");
		if (typeof data.total != "undefined") {
			pagination.total = data.total;
			$('.titleBar .tab.active .count').text(pagination.total);
			pagination.addPages();
		}
		bindPlayerActions();
		$('.content #request').on('click', bindPlayerActions);
	});
};

pagination.getCurrentRequest = function(requestId) {
    return (pagination.requests || requests || []).filter(function(r) {
        return r.requestId === (requestId || pagination.currentRequestId);
    })[0];
};

pagination.calculatePages = function() {
    return Math.ceil(this.total/this.pageSize);
};

pagination.addPages = function() {
    if (this.pageNumberNavigation != null) {
        $('.pagination .pageNumber').empty();
        
        var totalPages = Math.ceil(parseInt(this.total) / parseInt(this.pageSize));
        var firstPage = 1;
        var lastPage = totalPages;
        var currentPage = parseInt(this.currentPage);
        var pagesToDisplay = Math.min(this.pageNumberNavigation.numberOfPages, totalPages);
        var includeLastPageShortcut = false;
        var includeFirstPageShortcut = false;

        var endPage = currentPage + (pagesToDisplay - 1);
        endPage = endPage > lastPage ? lastPage : endPage;

        var startPage = endPage - (pagesToDisplay - 1);
        startPage = startPage < firstPage ? firstPage : startPage;

        if (lastPage - endPage <= 2) {
            endPage = lastPage;
        } else {
            includeLastPageShortcut = true;
        }

        if (firstPage - startPage <= 2 && currentPage === lastPage && startPage !== firstPage) {
            includeFirstPageShortcut = true;
        }

        if (includeFirstPageShortcut || includeLastPageShortcut) {
            pagesToDisplay -= 1;

            if (currentPage == lastPage) {
                startPage += 1;
            }
        }

        if (includeFirstPageShortcut) {            
            $('.pagination .pageNumber').append("<div class='pageNumberButton' onclick='pagination.getNewList(\"" + this.objType + "\", " + firstPage + ")'>" + firstPage + "</div>");
            $('.pagination .pageNumber').append("<div class='pageNumberButton'>...</div>");
        }

        for (var pageCounter = 0; pageCounter < pagesToDisplay; pageCounter++) {
            var pageNum = startPage + pageCounter;
            $('.pagination .pageNumber').append("<div class='pageNumberButton " + (currentPage === pageNum ? 'active' : '') + "' onclick='pagination.getNewList(\"" + this.objType + "\", " + pageNum + ")'>" + pageNum + "</div>");
        }

        if (includeLastPageShortcut) {            
            $('.pagination .pageNumber').append("<div class='pageNumberButton'>...</div>");
            $('.pagination .pageNumber').append("<div class='pageNumberButton' onclick='pagination.getNewList(\"" + this.objType + "\", " + lastPage + ")'>" + lastPage + "</div>");
        }
    } else {
        $('.pagination .currentPage').text($('.pagination .currentPage').text()+" of "+this.calculatePages());
    }
};

pagination.calculateStart = function(where) {
    var newStart;

    if (where == 'up') {
        newStart = this.start+this.pageSize;
    } else if (where == 'down') {
        newStart = this.start-this.pageSize;
    } else if (typeof where == 'number') {
        newStart = (where - 1) * this.pageSize;
    }
    return newStart;
};

pagination.setCurrentPage = function(where) {
	if (where == 'up') {
		this.currentPage++;
	} else if (where == 'down') {
		this.currentPage--;
	} else if (typeof where == 'number'){
		this.currentPage = where;
	}
	$('.pagination .currentPage').text(this.currentPage);
};

pagination.showHidePrev = function(amt) {
	if (this.currentPage < 2) {
		$('.pagination .prevPage').hide();
	} else {
		$('.pagination .prevPage').show();
	}
	if (amt < this.pageSize) {
		$('.pagination .nextPage').hide();
	} else {
		$('.pagination .nextPage').show();
	}
};

pagination.reOrder = function(objType) {
	if (this.orderBy == 'desc') {
		this.orderBy = 'asc';
		$('.orderBy').removeClass('desc');
		$('.orderBy').addClass('asc');
	} else if (this.orderBy == 'asc') {
		this.orderBy = 'desc';
		$('.orderBy').removeClass('asc');
		$('.orderBy').addClass('desc');
	}
	pagination.getNewList(objType,1);
};

pagination.urlsMapping = {};
pagination.urlsMapping[['seller', 'request']] = 'seller-request-list-json';
pagination.urlsMapping[['seller', 'quote']] = 'seller-quote-list-json';
pagination.urlsMapping[['buyer', 'request']] = 'buyer-request-list-json';
pagination.urlsMapping[['buyer', 'quote']] = 'buyer-quote-list-json';
// pagination.urlsMapping[['uhl', 'request']] = 'uhl-request-list-json'; TODO:: Remove UHL
// pagination.urlsMapping[['uhl', 'quote']] = 'uhl-quote-list-json'; TODO:: Remove UHL

pagination.buildNewListUrl = function(objType, newStart) {
	//buyer-quote-list-json is broken and needs buyer=true to return the proper stuff
	var buyHack = this.clientType == 'buyer' && objType == 'quote' ? '&buyer=true' : '';
	var newUrl = this.urlsMapping[[this.clientType, objType]];
	newUrl += '?start=' + (newStart ? newStart : 0) +
	'&pageSize='+ (this.pageSize ? this.pageSize : 0)+
	'&type='+ (this.type ? this.type : '')+
	'&orderBy='+(this.orderBy ? this.orderBy : '')+
	'&adminId='+(this.adminId ? this.adminId : '')+
	'&month_year_from='+(this.month_year_from ? this.month_year_from : '')+
	'&month_year_to='+(this.month_year_to ? this.month_year_to : '');
	if (this.requestId) {
        newUrl += '&requestId=' + this.requestId;
	}
	var cardboardFilter = $('#cardboard-filter').val();
	if (cardboardFilter) {
        newUrl += '&cta=' + cardboardFilter;
	}
	if (this.realtorId) {
		newUrl += '&realtorId=' + this.realtorId;
    }
	if (this.lowEstimate || this.highEstimate) {
		newUrl += '&lowEstimate=' + (this.lowEstimate || '') + '&highEstimate=' + (this.highEstimate || '');
	}
	var sortParam = "&sort=";
	if (this.sort == 'alsoBuying' && this.clientType == 'buyer') {
		sortParam += 'amLastUpdated';
		this.sort = 'amLastUpdated';
	} else if (this.sort == 'pendingDate' && this.clientType == 'buyer') {
		sortParam += 'signedDate';
		this.sort = 'signedDate';
	} else if (this.sort == 'signedDate' && this.clientType != 'buyer') {
		sortParam += 'listDate';
		this.sort = 'listDate';
	} else if (this.sort == 'listDate' && this.clientType == 'buyer') {
		sortParam += 'signedDate';
		this.sort = 'signedDate';
	} else if (this.sort == 'sellerPct' && this.clientType == 'buyer') {
		sortParam += 'rebatePercent';
		this.sort = 'rebatePercent';
	} else if (this.sort == 'rebatePercent' && this.clientType != 'buyer') {
		sortParam += 'sellerPct';
		this.sort = 'sellerPct';
	} else if (this.sort === 'createdOnTimestamp') {
	    sortParam += 'createdOn';
	} else if (this.sort == 'matchDate' && this.clientType == 'seller') {
	    sortParam += 'awardedDate';
	    this.sort = 'awardedDate';
	} else if (this.sort == 'awardedDate' && this.clientType == 'buyer') {
	    sortParam += 'matchDate';
	    this.sort = 'matchDate';
	} else {
		sortParam += this.sort;
	}
	if(sortParam) {
        newUrl += sortParam;
    }
	if (this.brand != null){
		var brand = this.brand;
		var flow = '';

		if (this.brand.includes('_FLOW_')){
			var splittedFilter = this.brand.split('_FLOW_');
			brand = splittedFilter[0];
			flow = splittedFilter[1];
		}

		newUrl += '&brand=' + brand + '&flow=' + flow;
	}
	if (this.timeZone != null){
		newUrl += '&timeZone=' + this.timeZone;
	}
	newUrl += buyHack;
	return newUrl
}

function mainListTop() {
	$('html,body').animate({scrollTop: 0},'slow');
	$('main section.mainList').scrollTop(0);
}

function returnPrettyDate(time) {
	var d;
	if (typeof time == "number") {
		d = new Date(time);
	} else if (typeof time == "string") {
		d = new Date(Date.parse(time));
	} else if (time instanceof Date) {
        d = time;
	}
	return moment(d).format('MM/DD/YY  HH:mm');
}

function activeTab(obj) {
	$('.titleBar .tab').removeClass('active');
	$(obj).addClass('active');
}

function getSixMonthsOldDate() {
  var currentDate = new Date();
  var sixMonthsOldDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6));

  var month = String(sixMonthsOldDate.getMonth() + 1).padStart(2, '0');
  var day = String(sixMonthsOldDate.getDate()).padStart(2, '0');
  var year = sixMonthsOldDate.getFullYear();

  return month + '/' + day + '/' + year;
}

function openCSVPage() {
	if (pagination.clientType == 'buyer' /*|| pagination.clientType === 'uhl' TODO:: Remove UHL */) {
		window.open(
			'list-buyer-request?adminId=' + pagination.adminId +
				'&format=somevalue&type=' + pagination.type +
				'&sort=' + pagination.sort +
				'&orderBy=' + pagination.orderBy +
				'&month_year_from=' + pagination.month_year_from +
				'&month_year_to=' + pagination.month_year_to +
				'&cta=' + getParameterByName('cta') +
				'&brand=' + pagination.brand,
			'_blank');
	} else {
		if (pagination.sort == 'createdOnTimestamp') {
			pagination.sort = 'createdOn';
		}
		window.open(
			'listRequest?adminId=' + pagination.adminId +
					'&format=somevalue&type=' + pagination.type +
					'&sort=' + pagination.sort +
					'&orderBy=' + pagination.orderBy +
					'&month_year_from=' + pagination.month_year_from +
					'&month_year_to=' + pagination.month_year_to +
					'&cta=' + (getParameterByName('cta') || '') +
					'&brand=' + pagination.brand,
			'_blank');
		window.open(
			'listRequestCustomCSV?adminId=' + pagination.adminId +
				'&format=somevalue&type=' + pagination.type +
				'&sort=' + pagination.sort +
				'&orderBy=' + pagination.orderBy +
				'&month_year_from=' + (pagination.month_year_from || getSixMonthsOldDate()) +
				'&month_year_to=' + pagination.month_year_to +
				'&cta=' + (getParameterByName('cta') || '') +
				'&brand=' + (pagination.brand || ''),
			'_blank');
	}
}

// admin comments functions on list pages
function toggleAdminNotesIcon(param, num) {
    var close = $(param).closest('.collapsible-panel').find('.admin-comment-close');
    var open = $(param).closest('.collapsible-panel').find('.admin-comment-open');
     if(open.css('display') == 'none'){
         if(num > 2) {
             close.hide();
             open.show();
             $(param).find('.collapseText').text('Expand');
         }
    }else{
         if(num > 2) {
             close.show();
             open.hide();
             $(param).find('.collapseText').text('Collapse');
         }
    }
}

function showTwoAdminCommentOnLoad() {
    $('ul.adminCommentList').each(function() {
        var _this = $(this);
        if(_this.children().length >2){
            _this.children().slice(2).hide();
        }else if(_this.closest('.notesSection').find('.allNotes .item .panel').length < 1){
            // _this.closest('.collapsible-panel').find('.admin-comment-open').hide();
            // _this.closest('.collapsible-panel').find('.collapseText').css('visibility', 'hidden');
			toggleAdminNotesIcon(_this,  _this.children().length);
        }
    });
}

function toggleAdminEmails(){
    $header = $(".admin-emails-header");
    //getting the next element
    $content = $header.next();
    //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
    $content.slideToggle(500, function () {
        //execute this after slideToggle is done
        //change text of header based on visibility of content div
        $header.text(function () {
            //change text based on condition
            return $content.is(":visible") ? "Collapse" : "Expand";
        });
    });
}

function toggleAdminNewNotes(param) {
     var adminCommentListItem = $(param).closest('.collapsible-panel').find('.admin-comment-list-item');
          adminCommentListItem.each(function(indx){
             var _this = $(this);
            if (_this.css('display') == 'none' && indx >= 2) {
                  _this.show();
            }else if(_this.css('display') == 'block' && indx >= 2){
                _this.hide();
            }
          });
    // toggleAdminNotes();
    toggleAdminNotesIcon(param, adminCommentListItem.length);
    initCollapsibleComments();
}

function toggleAgentComment(param) {
    var newNotes = $(param).closest('.notesSection').find('.collapsible-panel');
    if(newNotes){
        return;
    }
	// toggleAdminNotes();
}

function toggleAdminNotes() {
    if ($('.allNotes .panel.panel-primary').is(':visible')) {
		$('.allNotes .panel.panel-primary').hide();
		$('.smallAdminNotes').show();
	} else {
		$('.smallAdminNotes').hide();
		$('.allNotes .panel.panel-primary').show();
	}
}

//Badge List page functionalities
function displayBadgeInHeader(){
		var $badgeContainer = $('.inner-badge-container');
		var $headerBadge = $('.header-badge');
	  var badgeImageLink,
		    badgeTitle,
		    badgeDescription = '';

		//Display clicked badge in header
		$badgeContainer.on('click', function(e){
			e.preventDefault();

			var $currentBadge = $(this);
			badgeImageLink    = $currentBadge.find('.icon-design img').attr('src');
			badgeTitle        = $currentBadge.find('h4').html();
			badgeDescription  = $currentBadge.find('.inner-badge-text input').val();

      $headerBadge.find('.icon-design img').attr('src', badgeImageLink.slice(0, -4) + "-large.png?v2");
			$headerBadge.find('.inner-badge-text h4').html(badgeTitle );
			$headerBadge.find('.inner-badge-text p').html(badgeDescription);
			$headerBadge.slideDown();
			//scroll to top
			$('html, body').animate({scrollTop : 0},800);
		});


   //Hide badge in the header
		$headerBadge.on('click', function(e){
			e.preventDefault();
			$(this).slideUp();
		});
};

function toggleOptions(){
	$(".notifyButtons").slideToggle();
}

//Zestimage Graph
function zestimateGraph(){
	var $zGraphBrn      = $('.zGraphBrn'),
	    $zGraphdropdown = $('.zGraphdropdown'),
			$zArrowUp       = $('.zArrowUp'),
			$zArrowDown     = $('.zArrowDown');

			$zGraphBrn.on('click', function(){
				$zGraphdropdown.slideToggle();
				$zArrowUp.toggle();
				$zArrowDown.toggle();
			});
}

function bindAutocomplete(geoCity){
	/* GOOGLE PLACES AUTOFILL */

	var defaultBounds = getDefaultBounds(geoCity);

	var input = document.getElementById('address');
	var options = {
		bounds: defaultBounds,
		types: ['geocode'],
		componentRestrictions: {country: 'us'}
	};
	autocomplete = new google.maps.places.Autocomplete(input, options);
	$('#address').focus(function () {
		$('#address').removeClass('hasPlaceholder');
	});

	$('#address').live("paste",function(e) {
	  e.preventDefault();
	});

	google.maps.event.addListener(autocomplete, 'place_changed', function() {
		var autoZip = '';
		var place = autocomplete.getPlace();
		for (i in place.address_components) {
			if (place.address_components[i].types == "postal_code") {
				autoZip = place.address_components[i].long_name;
				$("#zip").val(autoZip);
				$("#selectedAddress").val($('#address').val());
				break;
			}
		}
	});
}

function getBuyTermsConditionsText() {
	return "Estimated refund amount is not guaranteed. Actual amount will vary based on the final purchase price, the gross commission the agent receives, and the percentages refunds the agent offers. Commission refunds are arranged and paid out by partner agents at the close of escrow, not by UpNest. UpNest does not accept buyer requests in states where commission refunds are prohibited by law: Oregon, Alaska, Iowa, Kansas, Oklahoma, Mississippi, Louisiana, Missouri, Alabama, and Tennessee. Commission refunds offered by UpNest partner agents are subject to adjustment or cancellation if the final purchase price is different from the purchase price range originally submitted by the buyer. Lender approval is required for commission refunds. In some conditions, lenders may not allow buyer to receive a commission refund. We recommend that buyers discuss commission refunds with the agents and lenders in advance.";
}

function showFullScreenBuyTermsConditionsTooltip(text, options) {
	options = options || {};

	var $popup = $('#popupContact');
	$popup.html('<div id="popupCloseButton" onclick="disablePopup()">&nbsp;</div><div id="customPopupDiv" style="overflow: auto;"></div>');
	var $popupContent = $('#customPopupDiv');
	$popupContent.html(text);
	centerPopup(null, null);

	var $window = $(window);
	$popup.css({
		top: $window.scrollTop() + ($window.height() / 2 - $popup.height() / 2 + options.offsetY),
		width: $window.width() - 30,
		left: ($window.width() / 2 - $popup.width() / 2) + 15,
		'border-radius': 10,
		hyphens: 'auto',
		height: 'auto'
	});
	$popupContent.css({
		height: '100%',
		'max-height': $window.height() - 40,
		padding: 0,
		margin: 20,
		width: 'auto'
	});

	loadPopup();
}

function addBuyTermsConditionsTooltip($link, options) {
	options = $.extend(options || {}, {
		offsetY: -150
	});

	if ($(window).width() < 768) {
		$link.on('focus click touchstart', function() {
			showFullScreenBuyTermsConditionsTooltip(getBuyTermsConditionsText(), {
				offsetY: options.offsetY
			});
		});
	} else {
		$link.tooltip($.extend({
			title: getBuyTermsConditionsText,
			template: '<div class="tooltip disclaimer-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
			trigger: 'hover focus',
			placement: 'top'
		}, options));
	}
}

// End Terms and Conditions Tooltips

function checkAgentTemplate(buy, responseId) {
	var url = buy ? 'checkAgentBuyTemplate-json' : 'checkAgentTemplate-json';
	$.post(url, function(data) {
		if (data == null || data == '' || data.msg == null || data.hasTemplate) {
			if (buy) {
				location.href = "oneClickSubmitBuyQuote?quoteId=" + responseId;
			} else {
				location.href = "oneClickSubmitQuote?quoteId=" + responseId;
			}
		} else if (typeof data.msg == 'string' && !data.hasTemplate) {
			if (buy) {
				customPopupContent("<div style='text-align:center'><img src='//www.lt6p.com/re/img/agent/fill_imd_template@2x.png' height='90' width='90'/></br></br>In order to use \"Quick Submit,\" please fill out a <a href=\"getDefaultBuyProposal\">proposal template</a>.<br/><br/><input type='button' class='btn btn-default' onclick='disablePopup()' value='OK'></div>", 250, 'auto');
			} else {
				customPopupContent("<div style='text-align:center'><img src='//www.lt6p.com/re/img/agent/fill_imd_template@2x.png' height='90' width='90'/></br></br>In order to use \"Quick Submit,\" please fill out a <a href=\"getDefaultProposal\">proposal template</a>.<br/><br/><input type='button' class='btn btn-default' onclick='disablePopup()' value='OK'></div>", 250, 'auto');
			}
		} else if (typeof data.msg == 'string') {
			if (buy) {
				location.href = "getDefaultBuyProposal?msg=" + data.msg;
			} else {
				location.href = "getDefaultProposal?msg=" + data.msg;
			}
		}
	}).error(function() {
		if (buy) {
			location.href = "oneClickSubmitBuyQuote?quoteId=" + responseId;
		} else {
			location.href = "oneClickSubmitQuote?quoteId=" + responseId;
		}
	});
}

function showYesNoPopup(question, yesCallback, noCallback) {
	var content = '<div style="word-wrap: break-word">'
		+ question
		+ '</div>'
		+ '<div style="margin-top: 30px">'
		+ '<button type="button" class="btn btn-default yes-button">Yes</button>'
		+ '<button type="button" class="btn btn-danger no-button" style="margin-left: 5px">No</button>'
		+ '</div>';
	customPopupContent(content, 320, 'auto');
	var $popup = $('#customPopupDiv');
	$popup.find('.yes-button').click(function() {
		if (yesCallback) {
			yesCallback() && disablePopup();
		} else {
			disablePopup();
		}
	});
	$popup.find('.no-button').click(function() {
		if (noCallback) {
			noCallback() && disablePopup();
		} else {
			disablePopup();
		}
	});
}

function showModal(html, options) {
	var defaultOptions = {
		bootstrapModalOptions: {
			show: true,
			backdrop: options && options.backdrop != null ? options.backdrop : true,
			keyboard: true,
			focus: true
		}
	};
	options = $.extend(defaultOptions, options);
	var $modal;
	if (options.modalContainer) {
		$modal = $(modalContainer).html(html);
	} else {
		$modal = $(html);
	}
	$modal.on('hidden.bs.modal', function() {
		$modal.remove();
	});
	if (typeof options.onClose == 'function') {
		$modal.on('hidden.bs.modal', options.onClose);
	}
	return $modal.modal(options.bootstrapModalOptions).modal('show');
}

function showSimpleTextModal(options) {
    if (typeof options == 'string') {
        options = {text: options};
    }
	var $modal = showModal(hb.templates.simpleTextModal({
		title: options.title,
		titleTextAlign: options.titleTextAlign,
		text: options.text,
		textAlign: options.textAlign || (options.title ? 'left' : ''),
		width: typeof options.width == 'number' ? options.width + 'px' : options.width,
		height: typeof options.height == 'number' ? options.height + 'px' : options.height,
		buttonTitle: options.buttonTitle || 'OK',
		showCloseButton: options.showCloseButton != null ? options.showCloseButton : true,
		textAlignButton: options.textAlignButton,
		showButton: true
	}));
	if (typeof options.onClose == 'function') {
		$modal.on('hidden.bs.modal', options.onClose);
	}
	return $modal;
}

function showReactModal(component, options, onClose) {
	var defaultOptions = {
		bootstrapModalOptions: {
			show: true,
			keyboard: true,
			focus: true,
			backdrop: true
		}
	};
	options = $.extend(defaultOptions, options);
	var $container = $('<div class="modal-container"></div>').appendTo('body');
	ReactDOM.render(component, $container[0]);
	return $container.find('.modal')
		.modal(options.bootstrapModalOptions)
		.on('hidden.bs.modal', function() {
			$container.remove();
			typeof onClose === 'function' && onClose();
		});
}

function abbreviateLines($element, maxLineCount) {
	var originalText = $element.text();
	var lineHeight = $element.text('Qq').height();
	var maxHeight = maxLineCount * lineHeight;
	$element.text(originalText);

	var words = $element.text().split(' ');
	while ($element[0].scrollHeight > maxHeight) {
		words.pop();
		var truncatedText = words.join(' ');
		var ellipsis = /\.\s*$/.test(truncatedText) ? '' : '...';
		$element.html(truncatedText + ellipsis);
	}
}

function clickReasonEvents(inputType) {
    var $customPopupDiv = $("#customReasonPopup");
    if(inputType === 'radio') {
        $customPopupDiv.find(".reason").on('change', function () {
            var $reason = $(".reason:checked");
            $customPopupDiv.find(".note").css("display", "none");
            if ($reason.val()) {
                $customPopupDiv.find(".other-reason").css("display", "none");
                $customPopupDiv.find("#submit_btn").removeClass("disabled");
                $customPopupDiv.find("#submit_btn").removeClass("disabled");
                $customPopupDiv.find(".note[for=" + $reason[0].id + "]").css("display", "block");
            } else {
                $customPopupDiv.find(".other-reason").css("display", "inline-block");
                if ($customPopupDiv.find(".other-reason").val() === "") {
                    $customPopupDiv.find("#submit_btn").addClass('disabled');
                }
            }
        });
        $customPopupDiv.find(".other-reason").on("change keyup paste", function () {
            if ($(this).val()) {
                $customPopupDiv.find("#submit_btn").removeClass("disabled");
            } else {
                $customPopupDiv.find("#submit_btn").addClass('disabled');
            }
        });
        $customPopupDiv.find('form').submit(function () {
            if ($customPopupDiv.find(".reason:checked").val()) {
                $customPopupDiv.find(".other-reason").attr('disabled', 'disabled');
            } else {
                $customPopupDiv.find(".reason").removeAttr('checked');
            }
        });
    } else if(inputType === 'checkbox') {
        $customPopupDiv.find(".reason").on('change', function (e) {
            var $reasons = $(".reason:checked");
            var isTextReason = $reasons.filter(function () {
                return this.value === ''
            }).length;

            if (isTextReason) {
                $customPopupDiv.find(".other-reason").css("display", "inline-block");
            } else {
                $customPopupDiv.find(".other-reason").css("display", "none");
            }

            var textarea = $customPopupDiv.find(".other-reason");

            if ($reasons.length > 1 || $reasons.length === 1 && !isTextReason || isTextReason && textarea.val()) {
                $customPopupDiv.find("#submit_btn").removeClass("disabled");
            } else {
                $customPopupDiv.find("#submit_btn").addClass('disabled');
            }
        });
        $customPopupDiv.find(".other-reason").on("change keyup paste", function () {
            var $reasons = $(".reason:checked");
            if ($reasons.length > 1 || $(this).val()) {
                $customPopupDiv.find("#submit_btn").removeClass("disabled");
            } else {
                $customPopupDiv.find("#submit_btn").addClass('disabled');
            }
        });
        $customPopupDiv.find('form').submit(function() {
            var $reasons = $(".reason:checked");
            var $textReason = $reasons.filter(function() {
                return this.value === '';
            });
            var textarea = $customPopupDiv.find(".other-reason");
            if (!$textReason.length || !textarea.val()) {
                $customPopupDiv.find(".other-reason").attr('disabled', 'disabled');
            }
            $textReason.removeAttr('checked');
        });
    }
}

function showReasonPopup(url, title, buttonName, options) {
    customPopupContentRounded(
        "customReasonPopup",
        hb.templates.reasonForm(options),
        '350px',
        'auto',
        '16px',
        title,
        url
    );
    $("#submit_btn").val(buttonName);
    var $popupContact = $("#popupContact");
    $popupContact.css('padding','30px 15px 15px');
    if ($(window).width() < 768) {
        $popupContact.width('calc(100% - 32px)');
        $popupContact.css('border-radius', '16px');
    }
    clickReasonEvents(options.inputType);
    $popupContact.css({left: $(window).width()/2 - ($popupContact.width() + 30)/2});
}

function showReactV2Modal(component, options, onClose) {
	var defaultOptions = {
		bootstrapModalOptions: {
			show: true,
			keyboard: true,
			focus: true,
			backdrop: true
		}
	};
	options = $.extend(defaultOptions, options);
	var $container = $('<div class="modal-container"></div>').appendTo('body');
	ReactDOMV2.render(component, $container[0]);
	return $container.find('.modal')
		.modal(options.bootstrapModalOptions)
		.on('hidden.bs.modal', function() {
			$container.remove();
			typeof onClose === 'function' && onClose();
		});
}

function openLTKTeamsModal(show, teamInfo, isProposal) {
	$modal = showReactV2Modal(window.ReactV2.createElement(window.reactComponents.LTKTeamsModal, {
		teamInfo: teamInfo,
		show: show,
		isProposal: isProposal
	}));
}

function clickDeclineRejectSeller(requestId, quoteId, admin, agentName, agentPhotoUrl, soldCount, yearsOfExp, proposalCount, quote) {
    $modal = showReactModal(React.createElement(reactComponents.Proposal.DeclineAgentModal, {
        requestId: requestId,
        responseId: quoteId,
        isBuyer: false,
        isAdmin: admin,
        agentName: agentName,
        agentPhotoUrl: agentPhotoUrl,
        soldCount: soldCount,
        yearsOfExp: yearsOfExp,
		proposalCount: proposalCount,
        onDeclineClick: function() {
            trackEvent('Quote', 'sellerClickDecline', null, {
                quoteId: quoteId,
                userId: global.currentUserId,
                has_voice_greeting: quote ? !!quote.voiceUrl : false,
                has_featured_video: quote && quote.realtor ? !!quote.realtor.featured_video : false,
                realtor_id: quote && quote.realtor ? quote.realtor.realtorId : null,
                proposal_id: quote ? quote.responseId : null
            });
        },
        closePopupAndUpdateProposalsClick: function() {
            $modal.modal('hide');
            pagination.getNewList('quote', pagination.currentPage ? parseInt(pagination.currentPage) : 1);
        }
    }));
}

function clickDeclineRejectBuyer(requestId, quoteId, admin, agentName, agentPhotoUrl, soldCount, yearsOfExp, proposalCount, quote) {
    $modal = showReactModal(React.createElement(reactComponents.Proposal.DeclineAgentModal, {
        requestId: requestId,
        responseId: quoteId,
        isBuyer: true,
        isAdmin: admin,
        agentName: agentName,
        agentPhotoUrl: agentPhotoUrl,
        soldCount: soldCount,
        yearsOfExp: yearsOfExp,
		proposalCount: proposalCount,
        onDeclineClick: function() {
            trackEvent('Quote', 'buyerClickDecline', null, {
                quoteId: quoteId,
                userId: global.currentUserId,
                has_voice_greeting: quote ? !!quote.voiceUrl : false,
                has_featured_video: quote && quote.realtor? !!quote.realtor.featured_video : false,
                realtor_id: quote && quote.realtor ? quote.realtor.realtorId : null,
                proposal_id: quote ? quote.responseId : null
            });
        },
        closePopupAndUpdateProposalsClick: function() {
            $modal.modal('hide');
            pagination.getNewList('quote', pagination.currentPage ? parseInt(pagination.currentPage) : 1);
        }
    }));
}


function clickDeclineRejectSellerLTK(requestId, quoteId, admin, agentName, agentPhotoUrl, soldCount, yearsOfExp, proposalCount, ltk, ft, tracking, dynamicModules, agentId) {
    $modal = showReactModal(React.createElement(reactComponents.Proposal.DeclineAgentModal, {
        requestId: requestId,
        responseId: quoteId,
        isBuyer: false,
        isAdmin: admin,
        agentName: agentName,
        agentPhotoUrl: agentPhotoUrl,
        soldCount: soldCount,
        yearsOfExp: yearsOfExp,
		proposalCount: proposalCount,
        // onDeclineClick: function() {
        //     trackEvent('Quote', 'sellerClickDecline', null, {
        //         quoteId: quoteId,
        //         userId: global.currentUserId,
        //         has_voice_greeting: quote ? !!quote.voiceUrl : false,
        //         has_featured_video: quote && quote.realtor ? !!quote.realtor.featured_video : false,
        //         realtor_id: quote && quote.realtor ? quote.realtor.realtorId : null,
        //         proposal_id: quote ? quote.responseId : null
        //     });
        // },
        closePopupAndUpdateProposalsClick: function() {
            $modal.modal('hide');
            pagination.getNewList('quote', pagination.currentPage ? parseInt(pagination.currentPage) : 1);
        },
		ltk: ltk ? '_ltk' : '',
		ft: ft  ? '_ft' : '',
		dynamicModules: dynamicModules,
		tracking: tracking == undefined ? 'turn_down_footer' : tracking,
		agentId: agentId
    }));
}

function clickDeclineRejectBuyerLTK(requestId, quoteId, admin, agentName, agentPhotoUrl, soldCount, yearsOfExp, proposalCount, ltk, ft, tracking, dynamicModules, agentId) {
    $modal = showReactModal(React.createElement(reactComponents.Proposal.DeclineAgentModal, {
        requestId: requestId,
        responseId: quoteId,
        isBuyer: true,
        isAdmin: admin,
        agentName: agentName,
        agentPhotoUrl: agentPhotoUrl,
        soldCount: soldCount,
        yearsOfExp: yearsOfExp,
		proposalCount: proposalCount,
        // onDeclineClick: function() {
        //     trackEvent('Quote', 'buyerClickDecline', null, {
        //         quoteId: quoteId,
        //         userId: global.currentUserId,
        //         has_voice_greeting: quote ? !!quote.voiceUrl : false,
        //         has_featured_video: quote && quote.realtor? !!quote.realtor.featured_video : false,
        //         realtor_id: quote && quote.realtor ? quote.realtor.realtorId : null,
        //         proposal_id: quote ? quote.responseId : null
        //     });
        // },
        closePopupAndUpdateProposalsClick: function() {
            $modal.modal('hide');
            pagination.getNewList('quote', pagination.currentPage ? parseInt(pagination.currentPage) : 1);
        },
		ltk: ltk ? '_ltk' : '',
		ft: ft  ? '_ft' : '',
		tracking: tracking,
		dynamicModules: dynamicModules,
		agentId: agentId

    }));
}

function escapeQuotes(s) {
	return s ? s.replace(/(['"])/g, '\\\$1') : s;
}

function submitImmediateDialog(responseId, isBuyer, requestId, agentId, agentEmail, agentName) {
    customPopupContent('<h1 style="margin-top:0">Submit Immediate Proposal</h1>' +
		'<div class="box text-header">Do you want to submit immediate proposal for ' + escapeQuotes(agentName)  + '?</div>' +
        '<input class="immediate-submit mediumredbutton" type="submit" value="Submit"></form>' +
        '<input type="button" value="Cancel" class="btn mediumredbutton" style="color:#555;background-color:#eee;border-color:#eee;margin-left:15px;" onclick="disablePopup()">', '300px', 'auto');

    var immediateSubmitButton = $('.immediate-submit');

    immediateSubmitButton.click(function(e) {
        var root = (isBuyer === 'buyer' || isBuyer === true)
            ? 'submitBuyImmediateProposal-json'
            : 'submitImmediateProposal-json';

        $.post(
            root,
            {
                requestId: requestId,
                email: agentEmail,
                suppressEmail: true,
                realtorIds: agentId
            }).always(function(data) {
            if (data.msg) {
                defaultAjaxError(data.msg);
            }
            disablePopup();
        });
    });
}

function remindPassword() {
	// This function is used in msg from backend in request flow. Don't move/delete it.
	var email = $('input[name=email]').val();
	if (email) {
		$.post("remindPassword", {email: email}).success(function() {
			customPopupContent('<h1>Password Reminder</h1>We’ve sent instruction to reset your password to ' + email +
					'. Please check your mailbox (and spam box) and contact our chat support if you do not receive the email. <br>'+
					'<input class="mediumredbutton" style="float:right" type="button" value="Close" onclick="disablePopup()"/>', '450', 'auto');
		}).fail(function() {
			customPopupContent('Sorry, reminder email sending failed, please try again or contact us at chat support', 'auto', 'auto');
		});
	}
}

function getYouTubeVideoId(url) {
	if (!url) { 
		return ''
	}
	var regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/;
    var match = url.match(regExp);
    return match && match[3];
}

// function getYouTubeVideoId(videoUrl) {
// 	if (videoUrl) {
// 		var regExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
// 		var match = videoUrl.match(regExp);
// 		if (match) {
// 			return match[1];
// 		}
// 	}
// 	return null;
// }

function showUploadListingAgreementPopup(data) {
	showReactModal(React.createElement(reactComponents.Proposal.PromoteListingModal, {
		requestId: data.requestId,
		responseId: data.quoteId,
		address: data.address,
        listingAgreementUrl: data.listingAgreementUrl
	}));
}

function extendDeep(parent, child) {
    var i,
        toStr = Object.prototype.toString,
        astr = "[object Array]";

    child = child || {};

    for (i in parent) {
        if (parent.hasOwnProperty(i)) {
            if (typeof parent[i] === "object") {
                child[i] = (toStr.call(parent[i]) === astr) ? [] : {};
                extendDeep(parent[i], child[i]);
            } else {
                child[i] = parent[i];
            }
        }
    }
    return child;
}

function handleAdminRequestTabs(tabElement) {
	var $tab = $(tabElement);
	if ($tab.hasClass('active')) {
		return;
	}

	var tabId = $tab.data('tab');
	$tab.parent().find('.tab.active').removeClass('active');
	$tab.addClass('active');
	$('.admin-request-overview').toggle(tabId === 'overview');
	$('.admin-notes').toggle(tabId === 'notes');
	$('.admin-loan-overview').toggle(tabId === 'loan');
}

function padStart(str, num, char) {
	if (!str) {
		return str;
	}
	if (String.prototype.padStart) {
		return str.padStart(num, char);
	} else {
		// IE 11 and older doesn't have padStart
		var paddedStr = str;
		for (var i = (num - str.length); i > 0; i--) {
			paddedStr = char + paddedStr;
		}
		return paddedStr;
	}
}

function formatDuration(ms) {
    var s = Math.floor((ms / 1000) % 60);
    var m = Math.floor((ms / 1000 / 60) % 60);
	var h = Math.floor(ms / 1000 / 3600);
	return [
		padStart(h.toString(), 2, '0'),
		padStart(m.toString(), 2, '0'),
		padStart(s.toString(), 2, '0')
	].join(':');
}

function resendReferralAgreement(realtorId, managingBrokerEmail, isBuy, onSuccess) {
	var url = isBuy ? 'resendBuyReferral-json' : 'resendReferral-json';
	$.post(url, {
		realtorId: realtorId,
	}).then(function(data) {
		if (checkAjax(data)) {
			var $modal = showSimpleTextModal({
				text: 'We’ve resent the invitation to sign referral agreement to your managing broker at ' + managingBrokerEmail,
				textAlign: 'center'
			});
			if (onSuccess) {
				onSuccess($modal);
			}
		}
	}).fail(function() {
		defaultAjaxError();
	});
}

function titleCase(string) {
	if (!string || typeof string != 'string' || string.length == 0) {
		return '';
	}
	var stringArray = string.split(' ');
	if (stringArray.length <= 1) {
		return string.charAt(0).toUpperCase() + string.substr(1);
	}
	return stringArray.map(function(str) {
		return str.charAt(0).toUpperCase() + str.substr(1);
	}).join(' ');
}

function pluralize(n, singular, plural) {
	return n + ' ' + (n == 1 ? singular : plural);
}

function trackSellRequestConversion(requestData) {
	if (!requestData) {
		return;
	}

	var requestUser = ((requestData ||{}).user || {});
	var isSuperUser = requestUser.admin || requestUser.manager || requestUser.userAgent;

	var estimate;
	if (requestData.zestimate) {
		estimate = requestData.zestimate;
	} else if (!requestData.lowRange) {
		estimate = requestData.highRange;
	} else {
		estimate = (+requestData.lowRange + +requestData.highRange) / 2 || 0;
	}
	var expectedRevenue = requestData.expectedRevenue;

	global.ec_email = (requestData.user || {}).email
	global.ec_phone = '+1' + (requestData.user || {}).phone
	gtag('set', 'user_data', {email: global.ec_email, phone_number: global.ec_phone});

	if (!logProduction
		|| isSuperUser
		|| (requestData.zestimate > 0 && requestData.zestimate < 50000)
		|| requestData.lowGreenAgentsCount
	) {
		// "beta" adwords
		var conversionValue;
			conversionValue = (estimate / 1000).toFixed(2);
		gtag('event', 'conversion', {
			send_to: 'AW-1026073853/Xz5sCLbN2_8CEP3JoukD',
			transaction_id: requestData.requestId,
			value: conversionValue,
			currency: 'USD'
		});
		console.log('Conversion value: ' + conversionValue);
		return;
	}

	// Bing
	(window.uetq = window.uetq || []).push({
		ea: 'sellerRequestConversion',
		gv: (estimate / 1000).toFixed(2)
	});

	// AdWords Conversion: Sell Request
	gtag('event', 'conversion_request', {
		value: (estimate / 1000).toFixed(2),
		currency: 'USD',
		transaction_id: requestData.requestId,
	});

	// AdWords Sell Expected Revenue conversion
	gtag('event', 'conversion_revenue', {
		value: expectedRevenue,
		currency: 'USD',
		ord: requestData.requestId,
		transaction_id: requestData.requestId,
	});

	// Optimizely (is it still needed?)
	window.optimizely.push(['trackEvent', 'sellerRequestConversion']);

	// Twitter Pixel
	$('head').append(hb.templates.sellerFlow.twitterPixel({
		txnId: 'ny0y6',
		saleAmount: Math.round(estimate)
	}));

	// Facebook Conversion Tracking Pixel
	fbq('track', 'CompleteRegistration', {
		value: estimate,
		currency: 'USD'
	});
	fbq('track', 'Purchase', {
		value: expectedRevenue,
		currency: 'USD'
	});

	// Quora Pixel
	qp('track', 'CompleteRegistration');

	// GDN Pixel
	gtag('event', 'conversion', {
		send_to: 'AW-434760111/8363CNORsPMBEK_Tp88B',
		transaction_id: requestData.requestId,
		value: expectedRevenue,
		currency: 'USD'
	});

	// Everflow Pixel
	$('body').append(hb.templates.sellerFlow.everflowPixel({transactionId: requestData.requestId}));
}

function trackBuyRequestConversion(requestData) {
	if (!requestData) {
		return;
	}

	var requestUser = ((requestData ||{}).user || {});
	var isSuperUser = requestUser.admin || requestUser.manager || requestUser.userAgent;

	var estimate;
	if (!requestData.lowRange) {
		estimate = requestData.highRange;
	} else {
		estimate = (+requestData.lowRange + +requestData.highRange) / 2 || 0;
	}

	if (!logProduction || isSuperUser) {
		// "beta" adwords
		// do we need this for buy requests?
		var conversionValue;

		conversionValue = Math.round(estimate / 1000);
		gtag('event', 'conversion', {
			send_to: 'AW-1026073853/Xz5sCLbN2_8CEP3JoukD',
			transaction_id: requestData.requestId,
			value: conversionValue,
			currency: 'USD'
		});

		console.log('Conversion value: ' + conversionValue);
		return;
	}

	var now = new Date();
	trackEvent('Flow', 'Request', 'buyRequestCreated', {
		convertedTime: now.getHours() + '' + now.getMinutes()
	}).withGA(Math.round(estimate / 1000));

	// Advida tracking pixel
	// $('body').append(
	//     '<iframe src="https://www.krishetrk.com/?nid=397&oid=218&transaction_id={sub3}" scrolling="no" frameborder="0" width="1" height="1"></iframe>'
	// );

	if (window.google_trackConversion) {
		google_trackConversion({
			google_conversion_id: 978838239,
			google_conversion_label: 'Z2yWCJnqvwgQ38Xf0gM',
			google_remarketing_only: false
		});
	}
	
	gtag('event', 'conversion_buy_request', {
		value: (estimate / 1000).toFixed(2),
		currency: 'USD',
		transaction_id: requestData.requestId,
		ord: requestData.requestId,
});
}

function fireGenericPixels() {
	if (!PRODUCTION) {
		return;
	}

	var verizonPixelUrl = CDN_URL + 'js/verizon-pixel.js?v=' + BUILD
	$('body').append('<script id="verizon-pixel"></script>');
	$('#nextdoor-pixel').attr({
		src:'https://beacon.krxd.net/event.gif?event_id=OAiZlIBx&event_type=pageview',
		width: 0,
		height: 0
	});	
	$.getScript( verizonPixelUrl,function() {console.log('loaded verizon')});
}

